<template>
  <el-dialog
    width="60%"
    :visible.sync="$store.state.sysInit.chatPiDiaLogVisible"
    class="dialog-data manul_chat_pi-dialog el-dialog__wrapper2"
    style="height: 100%"
    :modal-append-to-body="false"
    :show-close="false">
    <el-container>
      <el-aside
        width="310px"
        style="height: 556px; background-color: #d9d9d9; padding-left: 7px; padding-right: 7px">
        <!-- <span class="pi_coiiapse"> -->
        <div style="font-size: 13px; font-weight: bolder; padding-bottom: 20px; padding-top: 10px">
          お問い合わせ者リスト
          <el-dropdown @command="dropdownSort" placement="bottom" style="left: 95px">
            <span class="el-dropdown-link-chat">
              <span style="color: #9F014E; font-weight: normal; font-size: 13px">
                {{ this.$store.state.sysInit.dropdownSortTitle }}
              </span>
              <i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="width: 85px; text-align: center" >
              <el-dropdown-item command="sortByTime">先着順</el-dropdown-item>
              <el-dropdown-item command="sortBySimilarity">相性順</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div style="width: 290px; border-top: 1px solid #7f7f7f; z-index: 100"></div>
        <el-collapse class="cti_collapse">
          <!-- <input
                  style="left: 216px; top: 23px;    z-index: 100;"
                   class="switch switch-animbg"
                  v-model="$store.state.sysInit.chat_ChatingSortByTimeFlg"
                  @click.stop=""
                  type="checkbox"
                /> -->

          <el-collapse-item name="1" style="background-color: #d9d9d9">
            <template slot="title">
              <span style="font-size: 12px"
                >担当中のチャット({{
                  this.$store.state.sysInit.presenceInfoObj.chating_count
                }})</span
              >
              <!-- <input
                  style="left: 110px;
    top: 3px;   z-index: 100;"
                  class="switch switch-animbg"
                v-model="$store.state.sysInit.chat_ChatingSortByTimeFlg"
                  @click.stop=""
                  type="checkbox"
                /> -->
            </template>
            <template>
              <div>
                <el-table
                  :data="$store.state.sysInit.presenceInfoObj.chating"
                  :show-header="false"      
                  @row-click="getInfoFromchating"
                  :cell-style="{
                    borderColor: '#D9D9D9',
                    'border-width': '10px',
                    'background-color': 'white',
                    'cursor': 'pointer'
                  }"
                  :row-class-name="tablerowclassname"
                  :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data"
                  :key="1">
                  <template slot="empty">
                    <p style="text-align: center; font-size: 12px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </template>
                  <el-table-column width="20px">
                    <template slot-scope="scope">
                      <span
                        style="
                          left: 12px;
                          top: 10px;
                          position: absolute;
                          width: 30px;
                          z-index: 100;
                          color: #3e8f92;
                          font-size: 12px;
                        "
                        v-if="scope.row.similarity && scope.row.similarity != '0%'">
                        {{ scope.row.similarity }}
                      </span>

                      <span
                        style="
                          left: 12px;
                          top: 10px;
                          position: absolute;
                          width: 30px;
                          z-index: 100;
                          color: #3e8f92;
                          font-size: 12px;
                        "
                        v-if="scope.row.similarity && scope.row.similarity == '0%'">
                        --%
                      </span>
                      <span
                        style="
                          left: 12px;
                          top: 10px;
                          position: absolute;
                          width: 30px;
                          z-index: 100;
                          color: #3e8f92;
                          font-size: 12px;
                        "
                        v-if="!scope.row.similarity">
                        --%
                      </span>
                      <div style="display: flex" v-if="scope.row.heart_change_distance">
                        <div
                          id="img_head_back_table"
                          v-bind:style="{
                            top: 32 + scope.row.heart_change_distance + 'px',
                            height: 29 - scope.row.heart_change_distance + 'px',
                          }"></div>
                        <img
                          src="../assets/img/heart-white-current.svg"
                          class="img_heart_table"
                          v-if="scope.row.selected || (clickedRow && clickedRow['issueId'] == scope.row['issueId'])" />
                        <img src="../assets/img/heart-white.svg" class="img_heart_table" v-else />
                      </div>
                      <div style="display: flex" v-else>
                        <img
                          src="../assets/img/heart-white-current.svg"
                          class="img_heart_table"
                          v-if="scope.row.selected || (clickedRow && clickedRow['issueId'] == scope.row['issueId'])" />
                        <img src="../assets/img/heart-white.svg" class="img_heart_table" v-else />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      <span
                        style="
                          display: flex;
                          align-content: center;
                          flex-wrap: wrap;
                          justify-content: center;
                        ">
                        <span class="message_qu_name">
                          {{ $utils.computeFullName(scope.row.lastname, scope.row.firstname) }}
                        </span>
                        <br />

                        <el-badge
                          :value="scope.row.notReadNum"
                          :hidden="scope.row.notReadNum === 0">
                          <img class="img_questioner" :src="scope.row.logo_url" />
                          <br />
                          <!-- <span style="margin-left: 30px">
                            <icon name="small_star"></icon>
                            <icon name="small_star"></icon>
                          </span> -->
                        </el-badge>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="100px">
                    <template slot-scope="scope">
                      <div style="width: 100px; text-align: center">
                        <span class="message_time1"> {{ scope.row.time }}</span>
                        <div style="width: 95px; height: 2px; background: #00b2f2"></div>
                        <span class="message_presence">{{ scope.row.presenceStr }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template>
                      <span class="message_op_name"> {{ $store.state.sysInit.user_name }}</span>
                      <br />
                      <img :src="$store.state.sysInit.operator_logo" class="img_operatorPi" />
                      <div style="padding-bottom: 20px"></div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- </div> -->

              <!-- {{ this.$store.state.sysInit.piCallInfoObj.pi_calling}} -->
            </template>
          </el-collapse-item>
          <!-- <div style="padding:5px;"></div> -->
          <div style="width: 290px; border-top: 1px solid #7f7f7f; z-index: 100"></div>
          <!-- <input
                  style="left: 216px; top: 24px;    z-index: 100;"
                  class="switch switch-animbg"
                  v-model="$store.state.sysInit.chat_WaitingSortByTimeFlg"
                  @click.stop=""
                  type="checkbox"
                /> -->
          <el-collapse-item name="2">
            <template slot="title">
              <span style="font-size: 12px"
                >待ちチャット({{ this.$store.state.sysInit.presenceInfoObj.waiting_count }})</span
              >
              <!-- <input
                  style=" left: 133px;top: 3px;    z-index: 100;"
                  class="switch switch-animbg"
                v-model="$store.state.sysInit.chat_WaitingSortByTimeFlg"
                  @click.stop=""
                  type="checkbox"
                /> -->
            </template>
            <template>
              <div>
                <el-table
                  :data="$store.state.sysInit.presenceInfoObj.waiting"
                  :show-header="false"
                  :cell-style="{
                    borderColor: '#D9D9D9',
                    'border-width': '10px',
                    'background-color': 'white',
                    'cursor': 'pointer'
                  }"
                  :row-class-name="tablerowclassname"
                  @row-click="getQuestionerId"
                  :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data"
                  :key="2">
                  <template slot="empty">
                    <p style="text-align: center; font-size: 12px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </template>
                  <el-table-column width="20px">
                    <template slot-scope="scope">
                      <span
                        style="
                          left: 12px;
                          top: 10px;
                          position: absolute;
                          width: 30px;
                          z-index: 100;
                          color: #3e8f92;
                          font-size: 12px;
                        "
                        v-if="scope.row.similarity && scope.row.similarity != '0%'">
                        {{ scope.row.similarity }}
                      </span>

                      <span
                        style="
                          left: 12px;
                          top: 10px;
                          position: absolute;
                          width: 30px;
                          z-index: 100;
                          color: #3e8f92;
                          font-size: 12px;
                        "
                        v-if="scope.row.similarity && scope.row.similarity == '0%'">
                        --%
                      </span>
                      <span
                        style="
                          left: 12px;
                          top: 10px;
                          position: absolute;
                          width: 30px;
                          z-index: 100;
                          color: #3e8f92;
                          font-size: 12px;
                        "
                        v-if="!scope.row.similarity">
                        --%
                      </span>
                      <div style="display: flex" v-if="scope.row.heart_change_distance">
                        <div
                          id="img_head_back_table"
                          v-bind:style="{
                            top: 32 + scope.row.heart_change_distance + 'px',
                            height: 29 - scope.row.heart_change_distance + 'px',
                          }"></div>
                        <img
                          src="../assets/img/heart-white-current.svg"
                          class="img_heart_table"
                          v-if="scope.row.selected || (clickedRow && clickedRow['id'] == scope.row['id'])" />
                        <img src="../assets/img/heart-white.svg" class="img_heart_table" v-else />
                      </div>
                      <div style="display: flex" v-else>
                        <img
                          src="../assets/img/heart-white-current.svg"
                          class="img_heart_table"
                          v-if="scope.row.selected || (clickedRow && clickedRow['id'] == scope.row['id'])" />
                        <img src="../assets/img/heart-white.svg" class="img_heart_table" v-else />
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      <span
                        style="
                          display: flex;
                          align-content: center;
                          flex-wrap: wrap;
                          justify-content: center;
                        ">
                        <span class="message_qu_name">
                          {{ $utils.computeFullName(scope.row.lastname, scope.row.firstname) }}
                        </span>

                        <br />
                        <el-badge
                          :value="scope.row.notReadNum"
                          :hidden="scope.row.notReadNum === 0">
                          <img class="img_questioner" :src="scope.row.logo_url" />
                          <br />
                          <!-- <span style="margin-left: 30px">
                            <icon name="small_star"></icon>
                            <icon name="small_star"></icon>
                          </span> -->
                        </el-badge>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="100px">
                    <template slot-scope="scope">
                      <div style="width: 100px; text-align: center">
                        <span class="message_time"> {{ scope.row.time }}</span>
                        <div style="width: 95px; border-top: 2px dotted #00b2f2"></div>
                        <span class="message_presence">{{ scope.row.presenceStr }}</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template>
                      <span class="message_op_name"> 担当者未定</span>
                      <br />
                      <img src="../assets/img/exclamation.svg" class="img_operatorPi" />
                      <div style="padding-bottom: 20px"></div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-collapse-item>
          <!-- <div style="padding:5px;"></div> -->
          <div style="width: 290px; border-top: 1px solid #7f7f7f; z-index: 100"></div>
          <!-- <input
                  style="left: 216px; top: 20px;    z-index: 100;"
                  class="switch switch-animbg"
                  v-model="$store.state.sysInit.chat_EndingSortByTimeFlg"
                  @click.stop=""
                  type="checkbox"
                /> -->
          <el-collapse-item name="3">
            <template slot="title">
              <span style="font-size: 12px"
                >あなたがサポート完了したチャット({{
                  this.$store.state.sysInit.presenceInfoObj.ending_count
                }})</span
              >
              <!-- <input
                  style="left: 13px; top: 0px;    z-index: 100;"
                  class="switch switch-animbg"
                  v-model="$store.state.sysInit.chat_EndingSortByTimeFlg"
                  @click.stop=""
                  type="checkbox"
                /> -->
            </template>
            <template>
              <div>
                <div>
                  <el-table
                    :data="$store.state.sysInit.presenceInfoObj.ending"
                    :show-header="false"
                    :cell-style="{
                      borderColor: '#D9D9D9',
                      'border-width': '10px',
                      'background-color': 'white',
                      'cursor': 'pointer'
                    }"
                    :row-class-name="tablerowclassname"
                    @row-click="getIssueForEnding"
                    :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data"
                    :key="3">
                    <template slot="empty">
                      <p style="text-align: center; font-size: 12px">
                        {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                      </p>
                    </template>
                    <el-table-column width="20px">
                      <template slot-scope="scope">
                        <span
                          style="
                            left: 12px;
                            top: 10px;
                            position: absolute;
                            width: 30px;
                            z-index: 100;
                            color: #3e8f92;
                            font-size: 12px;
                          "
                          v-if="scope.row.similarity && scope.row.similarity != '0%'">
                          {{ scope.row.similarity }}
                        </span>

                        <span
                          style="
                            left: 12px;
                            top: 10px;
                            position: absolute;
                            width: 30px;
                            z-index: 100;
                            color: #3e8f92;
                            font-size: 12px;
                          "
                          v-if="scope.row.similarity && scope.row.similarity == '0%'">
                          --%
                        </span>
                        <span
                          style="
                            left: 12px;
                            top: 10px;
                            position: absolute;
                            width: 30px;
                            z-index: 100;
                            color: #3e8f92;
                            font-size: 12px;
                          "
                          v-if="!scope.row.similarity">
                          --%
                        </span>
                        <div style="display: flex" v-if="scope.row.heart_change_distance">
                          <div
                            id="img_head_back_table"
                            v-bind:style="{
                              top: 32 + scope.row.heart_change_distance + 'px',
                              height: 29 - scope.row.heart_change_distance + 'px',
                            }"></div>

                          <img
                            src="../assets/img/heart-white-current.svg"
                            class="img_heart_table"
                            v-if="scope.row.selected|| (clickedRow && clickedRow['issue_id'] == scope.row['issue_id'])" />
                          <img src="../assets/img/heart-white.svg" class="img_heart_table" v-else />
                        </div>
                        <div style="display: flex" v-else>
                          <img
                            src="../assets/img/heart-white-current.svg"
                            class="img_heart_table"
                            v-if="scope.row.selected || (clickedRow && clickedRow['issue_id'] == scope.row['issue_id'])" />
                          <img src="../assets/img/heart-white.svg" class="img_heart_table" v-else />
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column>
                      <template slot-scope="scope">
                        <span
                          style="
                            display: flex;
                            align-content: center;
                            flex-wrap: wrap;
                            justify-content: center;
                          ">
                          <span class="message_qu_name">
                            {{ scope.row.customer_name }}
                          </span>
                          <br />
                          <img class="img_questioner" :src="scope.row.logo_url" />
                          <br />
                          <!-- <span style="margin-left: 23px">
                            <icon name="small_star"></icon>
                            <icon name="small_star"></icon>
                          </span> -->
                        </span>
                      </template>
                    </el-table-column>

                    <el-table-column width="100px">
                      <template slot-scope="scope">
                        <div style="width: 100px; text-align: center">
                          <span class="message_time"> {{ scope.row.time }}</span>
                          <div style="width: 95px; height: 2px; background: #808080"></div>
                          <div class="message_presence">クローズ</div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column>
                      <template>
                        <span class="message_op_name"> {{ $store.state.sysInit.user_name }}</span>
                        <br />
                        <img :src="$store.state.sysInit.operator_logo" class="img_operatorPi" />
                        <div style="padding-bottom: 20px"></div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </template>
          </el-collapse-item>
        </el-collapse>
        <!-- </span> -->
      </el-aside>
      <el-container style="height: 573px">
        <el-main class="el-main_chat">
          <div style="height: 97%">
            <el-tabs type="border-card" v-model="activeTab">
              <!-- <el-tab-pane label="サマリー" v-if="this.$store.state.sysInit.showPiButton=='ok1'"> -->
              <el-tab-pane label="サマリー" name="summary_tab">
                <template
                  v-if="
                    this.$store.state.sysInit.piCustomerInfoEmptyFlg &&
                    this.$store.state.sysInit.piIssueListEmptyFlg
                  ">
                  <div style="height: 96.5%">
                    <div style="padding-bottom: 180px"></div>
                    <p style="text-align: center; font-size: 20px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </div>
                  <div style="margin-top: 30.5px"></div>
                </template>

                <template v-else>
                  <!-- サマリー・タブUI変更 #145 start-->
                  <div v-loading="this.$store.state.sysInit.piIssuesVisible" style="height: 100.2%">
                    <CTIDialogSummaryTab></CTIDialogSummaryTab>
                  </div>
                  <!-- サマリー・タブUI変更 #145 end-->
                </template>
                <div class="intrinsic-aspect-ratio-container_button_div">
                  <ManualChatButton></ManualChatButton>
                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                </div>
              </el-tab-pane>
              <el-tab-pane label="応対引継ぎ情報">
                <template
                  v-if="
                    !this.$store.state.sysInit.searchDetail_unsolvedIssueListVisible &&
                    this.$store.state.sysInit.unsolvedIssueList.length == 0
                  ">
                  <div style="height: 96.5%">
                    <div style="padding-bottom: 180px"></div>
                    <p style="text-align: center; font-size: 20px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </div>
                </template>
                <template v-else>
                  <div
                    v-loading="this.$store.state.sysInit.searchDetail_unsolvedIssueListVisible"
                    style="height: 100.2%">
                    <CTIDialogHistoryDetailTab></CTIDialogHistoryDetailTab>
                  </div>
                </template>
                <div class="intrinsic-aspect-ratio-container_button_div">
                  <ManualChatButton></ManualChatButton>
                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                </div>
              </el-tab-pane>
              <el-tab-pane label="お問い合わせ履歴">
                <template v-if="this.$store.state.sysInit.piIssueListEmptyFlg">
                  <div style="height: 96.55%">
                    <div style="padding-bottom: 180px"></div>
                    <p style="text-align: center; font-size: 20px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </div>
                </template>
                <template v-else>
                  <div v-loading="this.$store.state.sysInit.piIssuesVisible" style="height: 97.6%">
                    <div style="padding: 5px"></div>
                    <div style="padding: 10px">
                      クレーム検知：0件　長時間通話：{{
                        this.$store.state.sysInit.longTimeCount
                      }}件　NGワード：{{ this.$store.state.sysInit.ngCount }}件
                    </div>

                    <!-- <span
                      v-for="(menu, index) in this.categoryList"
                      :key="index"
                    >
                      <span style="padding: 5px">
                        <el-tag type="success">{{ menu }}</el-tag>
                      </span>
                    </span> -->
                    <!-- <div class="customer-table"> -->
                    <el-table
                      :data="this.$store.state.sysInit.PiIssueList"
                      style="width: 98%; margin-left: 10px"
                      height="375px"
                      border
                      :cell-style="cellStyle3"
                      :header-cell-style="{
                        color: '#FFFFFF',
                        background: '#4DB1EC',
                      }"
                      :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                      <el-table-column width="60%" align="center">
                        <template slot="header"> # </template>
                        <template slot-scope="scope">
                          <span></span>
                          <!-- <a href="https://aicc-dev-redmine.mybluemix.net/issues/" target="_blank">{{ scope.row.issue_id }}</a> -->
                          <a
                            style="color: #5ed4ff"
                            target="_blank"
                            :href="
                              $store.state.sysInit.html_const.cons_272_redmine_url +
                              scope.row.issue_id
                            "
                            >{{ scope.row.issue_id }}</a
                          >
                        </template>
                      </el-table-column>
                      <!-- <el-table-column prop="issue_id" label="#">
                      </el-table-column> -->
                      <el-table-column
                        prop="tracker_name"
                        label="トラッカー"
                        align="center"
                        width="120%">
                        <!-- <template slot="header" style="background:#B3B3B3">
                             トラッカー
                        </template> -->
                      </el-table-column>
                      <el-table-column
                        prop="category_tag"
                        label="カテゴリ"
                        align="center"
                        width="140%"
                        class-name="td-is-left">
                      </el-table-column>
                      <el-table-column
                        prop="subject_name"
                        label="タイトル"
                        align="center"
                        width="149%"
                        class-name="td-is-left">
                      </el-table-column>
                      <el-table-column prop="name" label="担当者" width="90%" align="center">
                      </el-table-column>
                      <el-table-column prop="finish_time" label="作成日" width="80%" align="center">
                      </el-table-column>
                      <el-table-column
                        prop="status_name"
                        label="ステータス"
                        width="150%"
                        align="center">
                      </el-table-column>
                      <el-table-column
                        prop="response_time"
                        label="応対時間"
                        width="80%"
                        align="center">
                      </el-table-column>
                    </el-table>
                    <!-- </div> -->
                  </div>
                </template>
                <el-col :span="20" class="intrinsic-aspect-ratio-container_button4"> </el-col>
                <div class="intrinsic-aspect-ratio-container_button_div">
                  <ManualChatButton></ManualChatButton>
                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                </div>
              </el-tab-pane>
              <el-tab-pane label="お客様情報">
                <template>
                  <template v-if="this.$store.state.sysInit.piCustomerInfoEmptyFlg">
                    <div style="height: 80.9%">
                      <div style="padding-bottom: 180px"></div>
                      <p style="text-align: center; font-size: 20px">
                        {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                      </p>
                    </div>
                    <div style="margin-top: 36px"></div>
                  </template>

                  <template v-else>
                    <div
                      v-loading="this.$store.state.sysInit.piCustomerVisible"
                      style="height: 88.9%">
                      <div style="padding: 10px"></div>
                      <div
                        style="
                          font-size: 20px;
                          background: #b3b3b3;
                          width: 867px;
                          height: 30px;
                          background: #4db1ec;
                          color: #ffffff;
                          padding: 5px;
                          margin-left: 10px;
                        ">
                        お客様情報
                      </div>
                      <div style="text-align: center">
                        <el-table
                          :data="this.$store.state.sysInit.customerInfo2"
                          style="width: 868px; margin-left: 9px"
                          size="medium"
                          border
                          :show-header="false"
                          :cell-style="cellStyle_1"
                          :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                          <el-table-column>
                            <!-- <template slot="header">
                            <span>お客様情報</span>
                          </template> -->

                            <el-table-column prop="label" width="155"> </el-table-column>
                            <el-table-column prop="value" width="279">
                              <template slot-scope="scope">
                                <span v-if="scope.row.label=='生年月日*' || scope.row.label=='登録日' 
                                || scope.row.label=='更新日'">
                                  <span v-if="scope.row.value">{{scope.row.value}}</span>
                                </span>
                                <span v-else>{{scope.row.value}}</span>
                              </template>
                            </el-table-column>

                            <el-table-column prop="label2" width="155"> </el-table-column>
                            <el-table-column prop="value2" width="278"> </el-table-column>
                          </el-table-column>
                          <!-- <el-table-column label="お客様情報"> -->

                          <!-- </el-table-column> -->
                        </el-table>
                      </div>
                    </div>

                    <!-- <el-table-column>
                        <template slot-scope="scope">
                          <span></span>
                          {{ scope.row.label }}
                        </template>
                      </el-table-column> -->
                  </template>
                  <!-- <el-row
                      :gutter="10"
                      style="padding-left: 5px; padding-right: 0px"
                    > -->
                  <el-col :span="20" class="intrinsic-aspect-ratio-container_button"> </el-col>
                  <!-- </el-row> -->
                  <div style="padding: 5px"></div>
                </template>
                <div class="intrinsic-aspect-ratio-container_button_div">
                  <ManualChatButton></ManualChatButton>
                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                </div>
              </el-tab-pane>
              <el-tab-pane label="プロフ検索" name="search_page">
                <div style="padding: 10px">
                  <el-row>
                    <el-col
                      :span="24"
                      style="text-align: center"
                      v-if="this.$store.state.sysInit.isShowSearchCondition">
                      <div class="search-condition-not-expanded">
                        <span style="font-weight: bolder">検索条件</span>
                        <i
                          class="el-icon-arrow-down"
                          @click="changeShowSearchCondition"
                          style="margin-left: 15px"></i>
                      </div>
                    </el-col>
                    <el-col :span="24" style="text-align: center" v-else>
                      <div class="search-condition-expanded">
                        <span style="font-weight: bolder">検索条件</span>
                        <i
                          class="el-icon-arrow-up"
                          @click="changeShowSearchCondition"
                          style="margin-left: 15px"></i>

                        <div style="padding: 10px"></div>
                        <el-form
                          :model="this.$store.state.sysInit.searchConditionForm"
                          label-width="100px"
                          size="mini">
                          <el-row :gutter="20">
                            <el-col :span="10" style="height: 40px" :offset="1">
                              <el-form-item prop="id">
                                <span slot="label" style="position: relative; top: 8px"> ID </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.id"
                                  style="width: 100%"
                                  disabled></el-input>
                              </el-form-item>
                            </el-col>

                            <el-col :span="10" style="height: 40px" :offset="2">
                              <el-form-item prop="name">
                                <span slot="label" style="position: relative; right: 53%; top: 8px">
                                  名前
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.name"
                                  style="width: 100%"
                                  placeholder="名前"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col :span="10" style="height: 40px" :offset="1">
                              <el-form-item prop="phone_number">
                                <span slot="label" style="position: relative; top: 8px">
                                  電話番号
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.phone_number"
                                  style="width: 100%"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="10" style="height: 40px" :offset="2">
                              <el-form-item prop="email">
                                <span slot="label" style="position: relative; right: 53%; top: 8px">
                                  メールアドレス
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.email"
                                  style="width: 100%"
                                  placeholder="XXX@YYY.com"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>

                          <el-row :gutter="20">
                            <el-col :span="10" style="height: 40px" :offset="1">
                              <el-form-item prop="birthday">
                                <span slot="label" style="position: relative; top: 8px">
                                  生年月日
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.birthday"
                                  style="width: 100%"
                                  placeholder="YYYY/MM/DD"></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="10" style="height: 40px" :offset="2">
                              <el-form-item prop="address">
                                <span slot="label" style="position: relative; right: 53%; top: 8px">
                                  住所
                                </span>
                                <el-input
                                  v-model="$store.state.sysInit.searchConditionForm.address"
                                  style="width: 100%"
                                  placeholder="XX県YY市ZZ1-2-3"></el-input>
                              </el-form-item>
                            </el-col>
                          </el-row>
                          <el-row :gutter="20">
                            <el-col
                              :span="10"
                              style="position: relative; right: 95px; height: 25px">
                              <el-form-item>
                                <el-button type="primary" @click="submitSearchConditionForm()"
                                  >検索</el-button
                                >
                                <el-button @click="resetSearchConditionForm()">クリア</el-button>
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-form>
                      </div>
                    </el-col>
                  </el-row>

                  <div
                    style="
                      width: 100%;
                      border-top: 1px solid #ccc;
                      z-index: 100;
                      margin-top: 10px;
                    "></div>
                  <el-row>
                    <el-col
                      :span="24"
                      style="text-align: center"
                      v-if="this.$store.state.sysInit.isShowSearchConsequence">
                      <div class="search-consequence-not-expanded">
                        <span style="font-weight: bolder">検索結果</span>
                        <i
                          class="el-icon-arrow-down"
                          @click="changeShowSearchConsequence"
                          style="margin-left: 15px"></i>
                      </div>
                    </el-col>
                    <el-col :span="24" style="text-align: center" v-else>
                      <div class="search-consequence-expanded">
                        <span style="font-weight: bolder">検索結果</span>
                        <i
                          class="el-icon-arrow-up"
                          @click="changeShowSearchConsequence"
                          style="margin-left: 15px"></i>
                      </div>
                      <div
                        style="
                          text-align: right;
                          padding-right: 15px;
                          padding-top: 10px;
                          padding-bottom: 0px;
                          font-weight: bolder;
                          font-size: 12px;
                        "
                        @click="addNewUserDialogOpen">
                        +新規顧客登錄する
                      </div>

                      <el-dialog
                        width="60%"
                        style="height: 100%"
                        class="dialog-data search-detail-dialog el-dialog__wrapper2"
                        :visible.sync="$store.state.sysInit.addNewUserDialogVisible"
                        append-to-body>
                        <span slot="title" class="el-dialog__title"> 新規顧客登錄 </span>
                        <el-tabs type="border-card">
                          <el-tab-pane label="お客様情報">
                            <div style="padding: 10px"></div>

                            <div
                              style="
                                font-size: 20px;
                                background: #53bce5;
                                color: #ffffff;
                                width: 896px;
                                height: 30px;
                                padding: 5px;
                                margin-left: 10px;
                              ">
                              お客様情報
                            </div>

                            <el-form
                              :model="this.$store.state.sysInit.newUserInfoForm"
                              label-width="100px"
                              size="mini"
                              style="position: relative; width: 950px; right: 3px">
                              <el-row :gutter="24">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 電話番号* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.phone_number"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目1 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -46px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> ID* </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input1"></el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目2 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -92px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 姓* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.lastname"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目3 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -138px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 名* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.firstname"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目4 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -184px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 読み* </span>
                                    </div>
                                    <el-input
                                      v-model="
                                        $store.state.sysInit.newUserInfoForm.customer_name_yomi
                                      "
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目5 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -230px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> メールアドレス* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.mail"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目6 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -276px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 分類 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input1"></el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目7 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -322px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <i
                                        class="el-icon-date"
                                        style="
                                          z-index: 100;
                                          left: 380%;
                                          position: relative;
                                          color: #c2c6ce;
                                          font-size: 12px;
                                        "></i>
                                      <span slot="label" style="position: relative; right: 16px">
                                        生年月日*
                                      </span>
                                    </div>
                                    <!-- <el-input v-model="$store.state.sysInit.newUserInfoForm.birthday" class="add-new-user-input1"></el-input> -->
                                    <el-date-picker
                                      style="width: 98%"
                                      class="add-new-user-input1"
                                      v-model="$store.state.sysInit.newUserInfoForm.birthday"
                                      type="date"
                                      prefix-icon="el-icon-platform-eleme">
                                    </el-date-picker>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目8 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -368px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 性别 </span>
                                    </div>
                                    <!-- <el-input v-model="$store.state.sysInit.newUserInfoForm.sex" class="add-new-user-input1"></el-input> -->
                                    <el-select
                                      v-model="$store.state.sysInit.newUserInfoForm.sex"
                                      placeholder="選んでください"
                                      class="add-new-user-input1">
                                      <el-option
                                        v-for="item in $store.state.sysInit.newUserGenderOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目9 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -414px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 前住所 </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.former_address"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目10 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -460px">
                                <el-col :span="11" :offset="1">
                                  <el-form-item>
                                    <div class="add-new-user-label1">
                                      <span slot="label"> 現住所* </span>
                                    </div>
                                    <el-input
                                      v-model="$store.state.sysInit.newUserInfoForm.current_address"
                                      class="add-new-user-input1">
                                      <i
                                        class="el-icon-edit"
                                        slot="suffix"
                                        style="right: 5px; position: relative"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                                <el-col :span="11">
                                  <el-form-item>
                                    <div class="add-new-user-label2">
                                      <span slot="label"> 拡張項目11 </span>
                                    </div>
                                    <el-input disabled class="add-new-user-input2"></el-input>
                                  </el-form-item>
                                </el-col>
                              </el-row>

                              <el-row :gutter="24" style="top: -425px; text-align: center">
                                <el-button type="primary" @click="submitNewUserForm()" size="small"
                                  >登錄</el-button
                                >
                                <el-button @click="resetNewUserForm()" size="small"
                                  >キャンセル</el-button
                                >
                              </el-row>
                            </el-form>
                          </el-tab-pane>
                        </el-tabs>
                      </el-dialog>

                      <el-table
                        v-loading="this.$store.state.sysInit.isSearchLoading"
                        :data="this.$store.state.sysInit.searchConsequence"
                        height="300px"
                        border
                        :header-cell-style="{
                          color: '#FFFFFF',
                          background: '#4DB1EC',
                        }"
                        :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data"
                        @row-click="changeHighlight"
                        @cell-mouse-leave="changeHighlight2"
                        ref="searchConsequenceTable">
                        <!-- <el-table-column label="ID" align="center" >
  </el-table-column> -->
                        <el-table-column prop="customer_name" label="名前" align="center">
                        </el-table-column>
                        <el-table-column prop="phone_number" label="電話番号" align="center">
                        </el-table-column>

                        <el-table-column prop="mail" label="メールアドレス" align="center">
                        </el-table-column>

                        <el-table-column
                          prop="birthday"
                          label="生年月日"
                          align="center"
                          :formatter="formatterBirthDay">
                        </el-table-column>
                        <el-table-column prop="current_address" label="住所" align="center">
                        </el-table-column>
                        <el-table-column prop="" label="詳細" align="center" width="70%">
                          <template slot-scope="scope">
                            <span @click.stop="chat_searchDetailed(scope.row)">
                              <img
                                src="../assets/img/search_user.png"
                                style="height: 20px; width: 20px" />
                            </span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="" label="本人確認" align="center">
                          <template slot-scope="scope">
                            <span v-if="$store.state.sysInit.manualChatPiStatus == 'OnThePhone'">
                              <el-button
                                type="primary"
                                size="mini"
                                style="padding: 5px"
                                @click="chatConfirmed(scope.row)"
                                :disabled="scope.row.is_confirmed == 1"
                                >本人確認</el-button
                              >
                            </span>
                            <span v-else>
                              <el-button
                                type="primary"
                                size="mini"
                                style="padding: 5px"
                                @click="chatConfirmed(scope.row)"
                                disabled
                                >本人確認</el-button
                              >
                            </span>
                          </template>
                        </el-table-column>
                      </el-table>
                    </el-col>
                  </el-row>
                </div>

                <div style="padding-top: 2.9%; text-align: center" @click="changeHighlight3">
                  <!-- <el-button
                    type="primary"
                    size="small"
                    plain
                    disabled
                    >サポート開始</el-button
                  > -->
                  <ManualChatButton></ManualChatButton>
                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                  <!-- <span @click="changeHighlight3">aaaaaaaaaaaaaaaaaaaa</span> -->
                </div>

                <el-dialog
                  width="60%"
                  style="height: 100%"
                  class="dialog-data search-detail-dialog el-dialog__wrapper2"
                  :visible.sync="$store.state.sysInit.searchDetailDialogVisible"
                  append-to-body>
                  <span slot="title">
                    顧客検索 -
                    {{ this.$store.state.sysInit.searchDetailTitle.id }} :
                    {{ this.$store.state.sysInit.searchDetailTitle.name }}さん
                  </span>
                  <el-tabs type="border-card">
                    <el-tab-pane label="サマリー">
                      <template
                        v-if="
                          this.$store.state.sysInit.searchDetail_piCustomerInfoEmptyFlg &&
                          this.$store.state.sysInit.searchDetail_piIssueListEmptyFlg
                        ">
                        <div style="height: 94.2%">
                          <div style="padding-bottom: 180px"></div>
                          <p style="text-align: center; font-size: 20px">
                            {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                          </p>
                        </div>
                        <div style="padding: 15px"></div>
                      </template>
                      <template v-else>
                        <div
                          v-loading="this.$store.state.sysInit.searchDetail_piIssuesVisible"
                          style="height: 100.8%">
                          <el-row :gutter="10" style="padding-left: 10px; padding-right: 10px">
                            <el-col :span="20">
                              <div class="wrapper">
                                <div style="padding: 3px"></div>
                                <div class="intrinsic-aspect-ratio-container3"></div>
                              </div>
                            </el-col>
                          </el-row>
                          <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                            <el-col
                              :span="10"
                              class="intrinsic-aspect-ratio-container_summary_1 wrapper_border">
                              <div style="margin-top: 5px"></div>
                              <span class="pi_title_color"> お客様情報</span>
                              <br />
                              <div style="margin-top: 5px"></div>
                              <template>
                                <el-col :span="5">
                                  <img
                                    class="img_questioner1"
                                    :src="this.$store.state.sysInit.searchDetailUserLogo" />

                                  <br />
                                  <!-- <span style="margin-left: 23px">
                                    <icon name="star"></icon>
                                    <icon name="star"></icon>
                                  </span> -->
                                </el-col>
                                <el-col :span="19">
                                  <el-table
                                    :data="this.$store.state.sysInit.searchDetail_customerInfo3"
                                    style="width: 100%; font-size: 10px"
                                    height="130px"
                                    :show-header="false"
                                    :cell-style="cellStyle"
                                    :empty-text="
                                      this.$store.state.sysInit.html_const.cons_219_no_data
                                    ">
                                    <el-table-column prop="label" label="" width="100">
                                    </el-table-column>
                                    <el-table-column prop="value" label="" width="200">
                                    </el-table-column>
                                  </el-table>
                                </el-col>
                              </template>
                            </el-col>
                            <span v-if="this.$store.state.sysInit.searchDetail_piEmptyFlg">
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container_summary_2 wrapper_border">
                                <p style="margin-top: 50px; text-align: center; font-size: 20px">
                                  {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                                </p>
                              </el-col>
                            </span>
                            <span v-else>
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container_summary_2 wrapper_border"
                                v-if="this.$store.state.sysInit.searchDetail_similarity != 'fail'">
                                <span class="pi_title_color"
                                  >{{ this.$store.state.sysInit.user_name }}との相性診断</span
                                >
                                <br />
                                <div style="padding-left: 94px; margin-top: 5px">
                                  <div
                                    style="
                                      margin-left: 101px;
                                      font-size: 16px;
                                      color: #009193;
                                      min-height: 16px;
                                    "
                                    v-html="
                                      this.$store.state.sysInit.searchDetail_similarity
                                    "></div>
                                  <div style="display: flex">
                                    <div class="element1">
                                      <img
                                        class="element1-picture1"
                                        :src="this.$store.state.sysInit.searchDetailUserLogo" />
                                    </div>
                                    <div class="rectangle1"></div>
                                    <div
                                      id="img_head_back_searchDetail"
                                      v-bind:style="{
                                        top:
                                          54 +
                                          this.$store.state.sysInit
                                            .searchDetail_heart_change_distance +
                                          'px',
                                        height:
                                          46 -
                                          this.$store.state.sysInit
                                            .searchDetail_heart_change_distance +
                                          'px',
                                      }"></div>
                                    <img
                                      src="../assets/img/heart-white.svg"
                                      class="img_heart_searchDetail" />
                                    <div class="rectangle2"></div>
                                    <div class="element1">
                                      <img
                                        class="element1-picture2"
                                        :src="$store.state.sysInit.operator_logo" />
                                    </div>
                                  </div>
                                </div>

                                <div style="margin-bottom: 25px"></div>
                                <span v-show="this.$store.state.sysInit.searchDetail_facetFlg">
                                  <div>
                                    <span
                                      style="font-weight: bold; color: #808080; padding-left: 20px">
                                      「心配性」
                                    </span>
                                    な{{
                                      this.$store.state.sysInit.searchDetail_customer_name
                                    }}さんには<br />
                                    <span style="padding-left: 30px">{{
                                      this.$store.state.sysInit.searchDetail_advice_info
                                    }}</span>
                                  </div>
                                </span>
                              </el-col>
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container_summary_2 wrapper_border"
                                v-else>
                                <p style="margin-top: 50px; text-align: center; font-size: 20px">
                                  {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                                </p>
                              </el-col>
                            </span>
                          </el-row>
                          <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                            <el-col
                              :span="20"
                              class="intrinsic-aspect-ratio-container2_Summary_call wrapper_border">
                              <template
                                v-if="this.$store.state.sysInit.searchDetail_piIssueListEmptyFlg">
                                <p style="margin-top: 50px; text-align: center; font-size: 20px">
                                  {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                                </p>
                              </template>
                              <template v-else>
                                <div>
                                  <div>
                                    <span class="pi_title_color" style="padding-right: 25px"
                                      >お問い合わせ履歴</span
                                    >
                                    クレーム検知：0件　長時間通話：{{
                                      this.$store.state.sysInit.searchDetail_longTimeCount
                                    }}件　NGワード：{{
                                      this.$store.state.sysInit.searchDetail_ngCount
                                    }}件
                                  </div>
                                  <div
                                    style="
                                      position: relative;
                                      margin-left: 15px;
                                      overflow: auto;
                                      min-height: 32px;
                                      display: flex;
                                      align-items: center;
                                    ">
                                    <span
                                      style="font-size: 10px; margin-right: 5px; color: #0000ff">
                                      AIチャットボット からエスカレーション
                                    </span>
                                    <span
                                      style="
                                        display: flex;
                                        flex-direction: row;
                                        flex-wrap: wrap;
                                        align-content: center;
                                        justify-content: flex-start;
                                        align-items: center;
                                      ">
                                      <span
                                        v-show="$store.state.sysInit.piIssueStatusFlg"
                                        v-for="(menu, index) in this.$store.state.sysInit
                                          .categoryList"
                                        :key="index">
                                        <span style="margin-left: 5px">
                                          <el-tag class="el-tag1" type="success">{{ menu }}</el-tag>
                                        </span>
                                      </span>
                                    </span>
                                  </div>
                                  <el-table
                                    :data="this.$store.state.sysInit.searchDetail_PiIssueList"
                                    style="font-size: 10px"
                                    class="customer-table"
                                    border
                                    :cell-style="cellStyle2"
                                    :header-cell-style="{
                                      color: '#FFFFFF',
                                      background: '#53BCE5',
                                    }"
                                    :empty-text="
                                      this.$store.state.sysInit.html_const.cons_219_no_data
                                    ">
                                    <el-table-column width="60%" align="center">
                                      <template slot="header"> # </template>
                                      <template slot-scope="scope">
                                        <span></span>
                                        <a
                                          style="color: #5ed4ff"
                                          target="_blank"
                                          :href="
                                            $store.state.sysInit.html_const.cons_272_redmine_url +
                                            scope.row.issue_id
                                          "
                                          >{{ scope.row.issue_id }}</a
                                        >
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="subject_name"
                                      label="タイトル"
                                      align="center"
                                      class-name="td-is-left">
                                    </el-table-column>
                                    <el-table-column
                                      prop="category_tag"
                                      label="カテゴリ"
                                      align="center"
                                      class-name="td-is-left">
                                    </el-table-column>
                                    <el-table-column
                                      prop="name"
                                      label="担当者"
                                      align="center"
                                      width="90%">
                                    </el-table-column>
                                    <el-table-column
                                      prop="finish_time"
                                      label="作成日"
                                      align="center"
                                      width="80%">
                                      <template slot-scope="scope">
                                        <span>{{scope.row.finish_time.replaceAll("-","/")}}</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="status_name"
                                      label="ステータス"
                                      align="center"
                                      width="100%">
                                    </el-table-column>
                                  </el-table>
                                </div>
                              </template>
                            </el-col>
                          </el-row>
                          <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                            <el-col :span="20" class="intrinsic-aspect-ratio-container_button_pi1">
                            </el-col>
                          </el-row>
                        </div>
                      </template>
                      <div class="intrinsic-aspect-ratio-container_button_div">
                        <el-button type="primary" size="small" plain disabled
                          >この人で特定</el-button
                        >
                        <el-button type="info" size="small" plain @click="searchDetailDialogClose"
                          >閉じる</el-button
                        >
                      </div>
                    </el-tab-pane>
                    <el-tab-pane label="お客様情報">
                      <template>
                        <template
                          v-if="this.$store.state.sysInit.searchDetail_piCustomerInfoEmptyFlg">
                          <div style="height: 89%">
                            <div style="padding-bottom: 180px"></div>
                            <p style="text-align: center; font-size: 20px">
                              {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                            </p>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            v-loading="this.$store.state.sysInit.searchDetail_piCustomerVisible"
                            style="height: 88.9%">
                            <div style="padding: 10px"></div>

                            <div
                              style="
                                font-size: 20px;
                                background: #53bce5;
                                color: #ffffff;
                                width: 896px;
                                height: 30px;
                                padding: 5px;
                                margin-left: 10px;
                              ">
                              お客様情報
                            </div>
                            <div style="text-align: center">
                              <el-table
                                :data="this.$store.state.sysInit.searchDetail_customerInfo2"
                                style="width: 896px; margin-left: 9px"
                                size="medium"
                                border
                                :show-header="false"
                                :cell-style="cellStyle_1"
                                :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                                <el-table-column>
                                  <el-table-column prop="label" width="165"> </el-table-column>
                                  <el-table-column prop="value" width="281"> 
                                    <template slot-scope="scope">
                                      <span v-if="scope.row.label=='生年月日*' || scope.row.label=='登録日' 
                                      || scope.row.label=='更新日'">{{scope.row.value.replaceAll("-","/")}}</span>
                                      <span v-else>{{scope.row.value}}</span>
                                    </template>
                                  </el-table-column>

                                  <el-table-column prop="label2" width="165"> </el-table-column>
                                  <el-table-column prop="value2" width="282"> </el-table-column>
                                </el-table-column>
                              </el-table>
                            </div>
                          </div>
                        </template>

                        <el-col :span="20" class="intrinsic-aspect-ratio-container_button_pi2">
                          <div class="intrinsic-aspect-ratio-container_button_div">
                            <!-- <CallStartButton></CallStartButton> -->
                            <el-button type="primary" size="small" plain disabled
                              >この人で特定</el-button
                            >
                            <el-button
                              type="info"
                              size="small"
                              plain
                              @click="searchDetailDialogClose"
                              >閉じる</el-button
                            >
                          </div>
                        </el-col>
                      </template>
                    </el-tab-pane>
                    <el-tab-pane label="性格推定結果">
                      <template v-if="this.$store.state.sysInit.searchDetail_piEmptyFlg">
                        <div style="height: 100.9%">
                          <div style="padding-bottom: 180px"></div>
                          <p style="text-align: center; font-size: 20px">
                            {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                          </p>
                        </div>
                      </template>

                      <template v-else>
                        <div
                          v-loading="this.$store.state.sysInit.searchDetail_piIssuesVisible"
                          style="height: 97.5%">
                          <template v-if="this.$store.state.sysInit.searchDetail_pimessageVisible">
                            {{ this.$store.state.sysInit.searchDetail_noContentsMessage }}
                          </template>
                          <template v-else v-cloak>
                            <div style="padding: 5px"></div>
                            <el-row :gutter="10" style="padding-left: 10px; padding-right: 10px">
                              <el-col :span="20">
                                <div class="wrapper">
                                  <div class="intrinsic-aspect-ratio-container3">
                                    <span style="font-size: 16px">
                                      お問い合わせ者
                                      {{
                                        this.$store.state.sysInit.searchDetail_customer_name
                                      }}さんは
                                      <span style="font-size: 23px; font-weight: bold">
                                        「心配性」 なタイプ</span
                                      >
                                      です
                                    </span>
                                    <span
                                      style="font-size: 18px; margin-left: 20px;"
                                      :class="{
                                        veryHighPi: this.$store.state.sysInit.credibility_message.indexOf('非常に高い') > -1 , 
                                        highPi: this.$store.state.sysInit.credibility_message.indexOf('が高い') > -1 ,
                                        decentPi: this.$store.state.sysInit.credibility_message.indexOf('適正') > -1 ,
                                        lowPi: this.$store.state.sysInit.credibility_message.indexOf('低') > -1 
                                      }">
                                      {{
                                        this.$store.state.sysInit.searchDetail_credibility_message
                                      }}</span
                                    >
                                  </div>
                                </div>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container wrapper_border">
                                <span class="pi_title_color"> 特に強い性格の傾向</span>
                                <br />
                                <div style="padding: 5px"></div>
                                <span style="display: flex; align-items: center">
                                  <span class="pi_text_color_progress">
                                    {{ this.$store.state.sysInit.searchDetail_facet_title[0] }}
                                  </span>
                                  <span style="width='300px'"></span>
                                  <div class="pi_progress">
                                    <el-progress
                                      :stroke-width="14"
                                      :percentage="
                                        $store.state.sysInit.searchDetail_facet_value[0]
                                      "></el-progress>
                                  </div>
                                  <br />
                                </span>

                                <span style="display: flex; align-items: center">
                                  <span class="pi_text_color_progress">
                                    {{ this.$store.state.sysInit.searchDetail_facet_title[1] }}
                                  </span>
                                  <div class="pi_progress">
                                    <el-progress
                                      :stroke-width="14"
                                      :percentage="
                                        $store.state.sysInit.searchDetail_facet_value[1]
                                      "></el-progress>
                                  </div>
                                  <br />
                                </span>
                                <span style="display: flex; align-items: center">
                                  <span class="pi_text_color_progress">
                                    {{ this.$store.state.sysInit.searchDetail_facet_title[2] }}
                                  </span>
                                  <div class="pi_progress">
                                    <el-progress
                                      :stroke-width="14"
                                      :percentage="
                                        $store.state.sysInit.searchDetail_facet_value[2]
                                      "></el-progress>
                                  </div>
                                  <br />
                                </span>
                              </el-col>
                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container1 wrapper_border"
                                v-if="this.$store.state.sysInit.searchDetail_similarity != 'fail'">
                                <span class="pi_title_color"
                                  >{{ this.$store.state.sysInit.user_name }}との相性診断</span
                                >
                                <br />
                                <div
                                  style="
                                    margin-left: 190px;
                                    font-size: 16px;
                                    color: #009193;
                                    min-height: 16px;
                                    margin-top: 5px;
                                  "
                                  v-html="this.$store.state.sysInit.searchDetail_similarity"></div>
                                <div style="margin-left: 48px; margin-top: 10px">
                                  <div style="display: flex">
                                    <div class="element2">
                                      <img
                                        class="element2-picture1"
                                        :src="this.$store.state.sysInit.searchDetailUserLogo" />
                                    </div>
                                    <div class="rectangle2_1"></div>
                                    <div
                                      id="img_head_back2_searchDetail"
                                      v-bind:style="{
                                        top:
                                          62 +
                                          this.$store.state.sysInit
                                            .searchDetail_heart_change_distance_big +
                                          'px',
                                        height:
                                          55 -
                                          this.$store.state.sysInit
                                            .searchDetail_heart_change_distance_big +
                                          'px',
                                      }"></div>
                                    <img
                                      src="../assets/img/heart-white.svg"
                                      class="img_heart2_searchDetail" />
                                    <div class="rectangle2_2"></div>
                                    <div class="element2">
                                      <img
                                        class="element2-picture2"
                                        :src="$store.state.sysInit.operator_logo" />
                                    </div>
                                  </div>
                                  <table style="margin-top: 25px; width: 91%">
                                    <tr>
                                      <td style="width: 50px; text-align: center">
                                        <span
                                          class="pi_text_color"
                                          style="right: 33%; position: relative">
                                          {{ this.$store.state.sysInit.searchDetail_customer_name }}
                                        </span>
                                      </td>
                                      <td style="width: 50px; text-align: center">
                                        <span
                                          class="pi_text_color"
                                          style="padding-left: 50%; position: relative"
                                          >{{ this.$store.state.sysInit.user_name }}</span
                                        >
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </el-col>

                              <el-col
                                :span="10"
                                class="intrinsic-aspect-ratio-container1 wrapper_border"
                                v-else>
                                <p style="margin-top: 50px; text-align: center; font-size: 20px">
                                  {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                                </p>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                              <el-col
                                :span="20"
                                class="intrinsic-aspect-ratio-container2 wrapper_border">
                                <span class="pi_title_color"> 性格推定結果の解説</span>
                                <br />
                                <div style="padding: 7px"></div>
                                <div class="pi_text_color">
                                  {{ this.$store.state.sysInit.searchDetail_facet_message[0] }}
                                </div>
                                <div class="pi_text_color">
                                  {{ this.$store.state.sysInit.searchDetail_facet_message[1] }}
                                </div>
                                <div class="pi_text_color">
                                  {{ this.$store.state.sysInit.searchDetail_facet_message[2] }}
                                </div>
                              </el-col>
                              <el-col
                                :span="20"
                                class="intrinsic-aspect-ratio-container4 wrapper_border">
                                <span class="pi_title_color">
                                  「心配性」な{{
                                    this.$store.state.sysInit.searchDetail_customer_name
                                  }}さんの攻略法</span
                                >
                                <br />
                                <div style="padding: 7px"></div>
                                <div class="pi_text_color">
                                  {{ this.$store.state.sysInit.searchDetail_advice_info }}
                                </div>
                              </el-col>
                            </el-row>
                            <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                              <el-col
                                :span="20"
                                class="intrinsic-aspect-ratio-container_button_pi3">
                              </el-col>
                            </el-row>
                          </template>
                        </div>
                      </template>
                      <div class="intrinsic-aspect-ratio-container_button_div">
                        <!-- <CallStartButton></CallStartButton> -->
                        <el-button type="primary" size="small" plain disabled
                          >この人で特定</el-button
                        >
                        <el-button type="info" size="small" plain @click="searchDetailDialogClose"
                          >閉じる</el-button
                        >
                      </div>
                    </el-tab-pane>

                    <el-tab-pane label="お問い合わせ履歴">
                      <template v-if="this.$store.state.sysInit.searchDetail_piIssueListEmptyFlg">
                        <div style="height: 96.7%">
                          <div style="padding-bottom: 180px"></div>
                          <p style="text-align: center; font-size: 20px">
                            {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                          </p>
                        </div>
                      </template>

                      <template v-else>
                        <div
                          v-loading="this.$store.state.sysInit.searchDetail_piIssuesVisible"
                          style="height: 96.6%">
                          <div style="padding: 5px"></div>
                          <div style="padding: 10px">
                            クレーム検知：0件　長時間通話：{{
                              this.$store.state.sysInit.searchDetail_longTimeCount
                            }}件　NGワード：{{
                              this.$store.state.sysInit.searchDetail_ngCount
                            }}件
                          </div>
                          <el-table
                            :data="this.$store.state.sysInit.searchDetail_PiIssueList"
                            style="width: 97%; margin-left: 10px"
                            height="375px"
                            border
                            :cell-style="cellStyle3"
                            :header-cell-style="{
                              color: '#FFFFFF',
                              background: '#53BCE5',
                            }"
                            :empty-text="this.$store.state.sysInit.html_const.cons_219_no_data">
                            <el-table-column width="65%" align="center">
                              <template slot="header"> # </template>
                              <template slot-scope="scope">
                                <span></span>
                                <a
                                  style="color: #5ed4ff"
                                  target="_blank"
                                  :href="
                                    $store.state.sysInit.html_const.cons_272_redmine_url +
                                    scope.row.issue_id
                                  "
                                  >{{ scope.row.issue_id }}</a
                                >
                              </template>
                            </el-table-column>

                            <el-table-column
                              prop="tracker_name"
                              label="トラッカー"
                              align="center"
                              width="120%">
                            </el-table-column>
                            <el-table-column
                              prop="category_tag"
                              label="カテゴリ"
                              align="center"
                              width="160%"
                              class-name="td-is-left">
                            </el-table-column>
                            <el-table-column
                              prop="subject_name"
                              label="タイトル"
                              align="center"
                              width="159%"
                              class-name="td-is-left">
                            </el-table-column>
                            <el-table-column prop="name" label="担当者" width="100%" align="center">
                            </el-table-column>
                            <el-table-column
                              prop="finish_time"
                              label="作成日"
                              width="80%"
                              align="center">
                              <template slot-scope="scope">
                                <span>{{scope.row.finish_time.replaceAll("-","/")}}</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="status_name"
                              label="ステータス"
                              width="120%"
                              align="center">
                            </el-table-column>
                            <el-table-column
                              prop="response_time"
                              label="応対時間"
                              width="80%"
                              align="center">
                            </el-table-column>
                          </el-table>
                        </div>
                      </template>
                      <el-col :span="20" class="intrinsic-aspect-ratio-container_button_pi4">
                        <div class="intrinsic-aspect-ratio-container_button_div">
                          <!-- <CallStartButton></CallStartButton> -->
                          <el-button type="primary" size="small" plain disabled
                            >この人で特定</el-button
                          >
                          <el-button type="info" size="small" plain @click="searchDetailDialogClose"
                            >閉じる</el-button
                          >
                        </div>
                      </el-col>
                    </el-tab-pane>
                    <el-tab-pane label="...">........</el-tab-pane>
                  </el-tabs>
                </el-dialog>
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"> 性格推定結果</span>
                <template v-if="this.$store.state.sysInit.piEmptyFlg">
                  <div style="height: 94.5%">
                    <div style="padding-bottom: 180px"></div>
                    <p style="text-align: center; font-size: 20px">
                      {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                    </p>
                  </div>
                  <div style="margin-top: 39.5px"></div>
                </template>
                <template v-else>
                  <div v-loading="this.$store.state.sysInit.piIssuesVisible" style="height: 98%">
                    <template v-if="this.$store.state.sysInit.pimessageVisible">
                      {{ this.$store.state.sysInit.noContentsMessage }}
                    </template>
                    <template v-else v-cloak>
                      <div style="padding: 5px"></div>
                      <el-row :gutter="10" style="padding-left: 10px; padding-right: 10px">
                        <el-col :span="20">
                          <div class="wrapper">
                            <div class="intrinsic-aspect-ratio-container3">
                              <span style="font-size: 16px">
                                お問い合わせ者
                                {{ this.$store.state.sysInit.customer_name }}さんは
                                <span style="font-size: 23px; font-weight: bold">
                                  「心配性」 なタイプ</span
                                >
                                です
                              </span>
                              <!-- <span style="font-size: 18px;margin-left: 12px;"> -->
                              <span style="font-size: 18px; margin-left: 20px; "
                              :class="{
                                veryHighPi: this.$store.state.sysInit.credibility_message.indexOf('非常に高い') > -1 , 
                                highPi: this.$store.state.sysInit.credibility_message.indexOf('が高い') > -1 ,
                                decentPi: this.$store.state.sysInit.credibility_message.indexOf('適正') > -1 ,
                                lowPi: this.$store.state.sysInit.credibility_message.indexOf('低') > -1 
                              }">
                                {{ this.$store.state.sysInit.credibility_message }}</span
                              >
                              <!-- </span> -->
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                      <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                        <!-- <el-col :span="10" class="intrinsic-aspect-ratio-container wrapper_border"> -->
                        <el-col :span="10" class="intrinsic-aspect-ratio-container wrapper_border">
                          <span class="pi_title_color"> 特に強い性格の傾向</span>
                          <br />
                          <div style="padding: 5px"></div>
                          <span style="display: flex; align-items: center">
                            <span class="pi_text_color_progress">
                              {{ this.$store.state.sysInit.facet_title[0] }}
                            </span>
                            <!-- <span style="width='300px'"></span> -->
                            <div class="pi_progress">
                              <el-progress
                                :stroke-width="14"
                                :percentage="$store.state.sysInit.facet_value[0]"></el-progress>
                            </div>
                            <br />
                          </span>

                          <span style="display: flex; align-items: center">
                            <span class="pi_text_color_progress">
                              {{ this.$store.state.sysInit.facet_title[1] }}
                            </span>
                            <div class="pi_progress">
                              <el-progress
                                :stroke-width="14"
                                :percentage="$store.state.sysInit.facet_value[1]"></el-progress>
                            </div>
                            <br />
                          </span>
                          <span style="display: flex; align-items: center">
                            <span class="pi_text_color_progress">
                              {{ this.$store.state.sysInit.facet_title[2] }}
                            </span>
                            <div class="pi_progress">
                              <el-progress
                                :stroke-width="14"
                                :percentage="$store.state.sysInit.facet_value[2]"></el-progress>
                            </div>
                            <br />
                          </span>
                          <!-- {{ this.facet_title }} -->
                        </el-col>
                        <!-- <el-col :span="10" class="intrinsic-aspect-ratio-container1 wrapper_border"> -->
                        <el-col
                          :span="10"
                          class="intrinsic-aspect-ratio-container1 wrapper_border"
                          v-if="this.$store.state.sysInit.similarity != 'fail'">
                          <span class="pi_title_color"
                            >{{ this.$store.state.sysInit.user_name }}との相性診断</span
                          >
                          <br />
                          <div
                            style="
                              margin-left: 190px;
                              font-size: 16px;
                              color: #009193;
                              min-height: 16px;
                              margin-top: 5px;
                            "
                            v-html="this.$store.state.sysInit.similarity">
                            <!-- 90% -->
                            <!-- {{this.$store.state.sysInit.similarity}} -->
                          </div>
                          <div style="margin-left: 48px; margin-top: 10px">
                            <div style="display: flex">
                              <div class="element2">
                                <img
                                  class="element2-picture1"
                                  :src="this.$store.state.sysInit.pi_chat_questioner_logo" />
                              </div>
                              <div class="rectangle2_1"></div>
                              <div
                                id="img_head_back2"
                                v-bind:style="{
                                  top:
                                    62 + this.$store.state.sysInit.heart_change_distance_big + 'px',
                                  height:
                                    55 - this.$store.state.sysInit.heart_change_distance_big + 'px',
                                }"></div>
                              <img src="../assets/img/heart-white.svg" class="img_heart2" />
                              <div class="rectangle2_2"></div>
                              <div class="element2">
                                <img
                                  class="element2-picture2"
                                  :src="$store.state.sysInit.operator_logo" />
                              </div>
                            </div>
                            <table style="margin-top: 25px; width: 91%">
                              <tr>
                                <td style="width: 50px; text-align: center">
                                  <span
                                    class="pi_text_color"
                                    style="right: 33%; position: relative">
                                    {{ this.$store.state.sysInit.customer_name }}
                                  </span>
                                </td>
                                <td style="width: 50px; text-align: center">
                                  <span
                                    class="pi_text_color"
                                    style="padding-left: 50%; position: relative"
                                    >{{ this.$store.state.sysInit.user_name }}</span
                                  >
                                </td>
                              </tr>
                            </table>
                          </div>
                        </el-col>

                        <el-col
                          :span="10"
                          class="intrinsic-aspect-ratio-container1 wrapper_border"
                          v-else>
                          <p style="margin-top: 50px; text-align: center; font-size: 20px">
                            {{ this.$store.state.sysInit.html_const.cons_265_chat_no_info }}
                          </p>
                        </el-col>
                      </el-row>
                      <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                        <!-- <el-col :span="20" class="intrinsic-aspect-ratio-container2 wrapper_border"> -->
                        <el-col :span="20" class="intrinsic-aspect-ratio-container2 wrapper_border">
                          <span class="pi_title_color"> 性格推定結果の解説</span>
                          <br />
                          <div style="padding: 7px"></div>
                          <div class="pi_text_color">
                            {{ this.$store.state.sysInit.facet_message[0] }}
                          </div>
                          <div class="pi_text_color">
                            {{ this.$store.state.sysInit.facet_message[1] }}
                          </div>
                          <div class="pi_text_color">
                            {{ this.$store.state.sysInit.facet_message[2] }}
                          </div>
                        </el-col>
                        <el-col :span="20" class="intrinsic-aspect-ratio-container4 wrapper_border">
                          <span class="pi_title_color">
                            「心配性」な{{
                              this.$store.state.sysInit.customer_name
                            }}さんの攻略法</span
                          >
                          <br />
                          <div style="padding: 7px"></div>
                          <div class="pi_text_color">
                            {{ this.$store.state.sysInit.advice_info }}
                          </div>
                          <!-- {{ this.advice_info }} -->
                        </el-col>
                      </el-row>
                      <el-row :gutter="10" style="padding-left: 5px; padding-right: 0px">
                        <el-col :span="20" class="intrinsic-aspect-ratio-container_button3">
                        </el-col>
                      </el-row>
                    </template>
                  </div>
                </template>

                <div class="intrinsic-aspect-ratio-container_button_div">
                  <ManualChatButton></ManualChatButton>
                  <el-button type="info" size="small" plain @click="closePiDialog"
                    >閉じる</el-button
                  >
                </div>
              </el-tab-pane>
            </el-tabs>
          </div></el-main
        >
        <!-- <el-footer>Footer</el-footer> -->
      </el-container>
    </el-container>

    <span slot="title" class="dialog-header">
      <span class="el-dialog__title">お問い合わせ者情報</span>
      <button type="button" class="el-dialog__headerbtn header-minbtn" @click="closePiDialog">
        <i class="el-icon-minus" style="color: white"></i>
      </button>
      <button type="button" class="el-dialog__headerbtn" @click="closePiDialog">
        <i class="el-icon-close" style="color: white"></i>
      </button>
    </span>
    <!-- <div style="height: 90%" v-loading="this.$store.state.sysInit.pi_loading"> -->
  </el-dialog>
</template>

<script>
import VueUtils from '@/utils/utils.js';
import Vue from "vue"
// import CallStartButton from "./CallStartButton.vue";
import { Message } from "element-ui";
import ManualChatButton from "./ManualChatButton.vue";
import CTIDialogHistoryDetailTab from "./CTIDialogHistoryDetailTab.vue";
import CTIDialogSummaryTab from "./CTIDialogSummaryTab.vue";
import sysInit from "../store/modules/sysInit";
import moment from "moment";
const _ = require("lodash");
import { orderBy, findIndex, reverse, sortBy, toPairs, find, chunk, remove, omit } from "lodash";
var sd = require("silly-datetime");
export default {
  components: {
    // CallStartButton,
    ManualChatButton,
    CTIDialogHistoryDetailTab,
    CTIDialogSummaryTab,
  },
  data() {
    return {
      categoryList: [],
      piRecordInfo: "",
      timer: "",
      timerChating: "",
      timerEnding: "",
      activeTab: "summary_tab",
      // chatingValue:false,
      // waitingValue:false,
      // endingValue:false,
      // userChecked:"primary",
      clickedRow: null,
    };
  },
  watch: {
    "$store.state.sysInit.chat_ChatingSortByTimeFlg": function () {
      this.ChatingSortByTime();
    },
    "$store.state.sysInit.chat_WaitingSortByTimeFlg": function () {
      this.waitingSortByTime();
    },
    "$store.state.sysInit.chat_EndingSortByTimeFlg": function () {
      this.endingSortByTime();
    },
  },

  mounted: function () {
    var _this = this;
    this.timer = setInterval(function () {
      for (let data of _this.$store.state.sysInit.presenceInfoObj.waiting) {
        if (data.startTime) {
          let timezone = 9;
          let offset_GMT = new Date().getTimezoneOffset();
          let nowDate = new Date().getTime();
          let time = sd.format(
            new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000),
            "YYYY-MM-DD HH:mm:ss"
          );
          var startTime = moment(
            new Date(data.startTime.replace(/T/g, " ").replace(/\.[\d]{3}Z/, ""))
          ).format("YYYY-MM-DD HH:mm:ss");
          let outTime = "";
          let hoursTime = "";
          let minutesTime = "";
          let secondsTime = "";
          let hours = moment(time).diff(moment(startTime), "hours");
          if (hours > 0) {
            if (hours < 10) {
              hoursTime = hoursTime + "0" + hours + "時";
            } else {
              hoursTime = hoursTime + hours + "時";
            }
          } else {
            hoursTime = hoursTime + "00時";
          }
          let minutes = moment(time).diff(moment(startTime), "minutes") % 60;
          if (minutes > 0) {
            if (minutes < 10) {
              minutesTime = minutesTime + "0" + minutes + "分";
            } else {
              minutesTime = minutesTime + minutes + "分";
            }
          } else {
            minutesTime = minutesTime + "00分";
          }
          let seconds = (moment(time).diff(moment(startTime), "seconds") % 60) % 60;
          if (seconds > 0) {
            if (seconds < 10) {
              secondsTime = secondsTime + "0" + seconds + "秒";
            } else {
              secondsTime = secondsTime + seconds + "秒";
            }
          } else {
            secondsTime = secondsTime + "00秒";
          }
          if (hours > 0) {
            outTime = hoursTime + "前";
          } else if (minutes > 0) {
            outTime = minutesTime + "前";
          } else if (seconds > 0) {
            outTime = secondsTime + "前";
          }
          data.time = outTime;
        }
      }
    }, 1000);
    this.timerChating = setInterval(function () {
      for (let data of _this.$store.state.sysInit.presenceInfoObj.chating) {
        if (data.startTime) {
          let timezone = 9;
          let offset_GMT = new Date().getTimezoneOffset();
          let nowDate = new Date().getTime();
          let time = sd.format(
            new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000),
            "YYYY-MM-DD HH:mm:ss"
          );
          var startTime = moment(
            new Date(data.startTime.replace(/T/g, " ").replace(/\.[\d]{3}Z/, ""))
          ).format("YYYY-MM-DD HH:mm:ss");
          let outTime = "";
          let hoursTime = "";
          let minutesTime = "";
          let secondsTime = "";
          let hours = moment(time).diff(moment(startTime), "hours");
          if (hours > 0) {
            if (hours < 10) {
              hoursTime = hoursTime + "0" + hours + "時";
            } else {
              hoursTime = hoursTime + hours + "時";
            }
          } else {
            hoursTime = hoursTime + "00時";
          }
          let minutes = moment(time).diff(moment(startTime), "minutes") % 60;
          if (minutes > 0) {
            if (minutes < 10) {
              minutesTime = minutesTime + "0" + minutes + "分";
            } else {
              minutesTime = minutesTime + minutes + "分";
            }
          } else {
            minutesTime = minutesTime + "00分";
          }
          let seconds = (moment(time).diff(moment(startTime), "seconds") % 60) % 60;
          if (seconds > 0) {
            if (seconds < 10) {
              secondsTime = secondsTime + "0" + seconds + "秒";
            } else {
              secondsTime = secondsTime + seconds + "秒";
            }
          } else {
            secondsTime = secondsTime + "00秒";
          }
          if (hours > 0) {
            outTime = hoursTime + "前";
          } else if (minutes > 0) {
            outTime = minutesTime + "前";
          } else if (seconds > 0) {
            outTime = secondsTime + "前";
          }

          data.time = outTime;
        }
      }
    }, 1000);
    this.timerEnding = setInterval(function () {
      for (let data of _this.$store.state.sysInit.presenceInfoObj.ending) {
        if (data.chat_end_time) {
          let timezone = 9;
          let offset_GMT = new Date().getTimezoneOffset();
          let nowDate = new Date().getTime();
          let time = sd.format(
            new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000),
            "YYYY-MM-DD HH:mm:ss"
          );
          var startTime = moment(
            new Date(data.chat_end_time.replace(/T/g, " ").replace(/\.[\d]{3}Z/, ""))
          ).format("YYYY-MM-DD HH:mm:ss");
          let outTime = "";
          let hoursTime = "";
          let minutesTime = "";
          let secondsTime = "";
          let hours = moment(time).diff(moment(startTime), "hours");
          if (hours > 0) {
            if (hours < 10) {
              hoursTime = hoursTime + "0" + hours + "時";
            } else {
              hoursTime = hoursTime + hours + "時";
            }
          } else {
            hoursTime = hoursTime + "00時";
          }
          let minutes = moment(time).diff(moment(startTime), "minutes") % 60;
          if (minutes > 0) {
            if (minutes < 10) {
              minutesTime = minutesTime + "0" + minutes + "分";
            } else {
              minutesTime = minutesTime + minutes + "分";
            }
          } else {
            minutesTime = minutesTime + "00分";
          }
          let seconds = (moment(time).diff(moment(startTime), "seconds") % 60) % 60;
          if (seconds > 0) {
            if (seconds < 10) {
              secondsTime = secondsTime + "0" + seconds + "秒";
            } else {
              secondsTime = secondsTime + seconds + "秒";
            }
          } else {
            secondsTime = secondsTime + "00秒";
          }
          if (hours > 0) {
            outTime = hoursTime + "前";
          } else if (minutes > 0) {
            outTime = minutesTime + "前";
          } else if (seconds > 0) {
            outTime = secondsTime + "前";
          }

          data.time = outTime;
        }
      }
    }, 1000);
  },
  beforeDestroy: function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.timerChating) {
      clearInterval(this.timerChating);
    }
    if (this.timerEnding) {
      clearInterval(this.timerEnding);
    }
  },
  methods: {
    formatterBirthDay(row) {
      // birthday may be null
      return row.birthday ? row.birthday.split("T")[0].replaceAll("-","/") : "";
    },
    // tableRowClassName({ row, rowIndex }) {
    //   if (row.userOnChecked) {
    //     return "success-row";
    //   }
    // },

    closePiDialog() {
      this.$store.state.sysInit.chatPiDiaLogVisible = false;
      if (this.$store.state.sysInit.presenceInfoObj.waiting.length > 0) {
        this.$store.state.sysInit.isBlingFlg = true;
      } else {
        this.$store.state.sysInit.isBlingFlg = false;
      }
    },
    handleChange(val) {
      console.log(val);
    },
    // getAllInfoToPi(val) {
    //   this.$store.dispatch("sysInit/getAllInfoToManualChatPi", {
    //     telNum: val,
    //   });
    //   this.categoryList = [];
    //   this.$store.state.sysInit.pi_loading = true;
    //   this.$store.state.sysInit.piIssuesVisible = true;
    //   this.$store.state.sysInit.piCustomerVisible = true;
    //   // this.$store.state.sysInit.piCallWaitVisible = true;
    //   // this.$store.state.sysInit.piRecordVisible = true;
    // },
    resetAllSelected(){
       _.forEach(this.$store.state.sysInit.presenceInfoObj.ending, function (value, key) {
        value.selected = false;
      });
      _.forEach(this.$store.state.sysInit.presenceInfoObj.waiting, function (value, key) {
        value.selected = false;
      });
      _.forEach(this.$store.state.sysInit.presenceInfoObj.chating, function (value, key) {
        value.selected = false;
      });

    },

    getIssueForEnding(row, event, colum) {
      this.clickedRow = row;
      this.$store.state.sysInit.temp_selected_logo_cti = row.logo_url;

      this.resetAllSelected();
      let val = row;
      val.current_ending = true;
      val.selected = true;

      Vue.set(this.$store.state.sysInit.presenceInfoObj.ending,0,this.$store.state.sysInit.presenceInfoObj.ending[0]);

      this.$store.state.sysInit.chat_current_status = "isEnding";
      // this.$store.state.discovery.autoCompleteInputText = "";
      this.$store.state.sysInit.piCustomerVisible = true;
      this.$store.state.sysInit.piChatbotVisible = true;
    
      this.$store.state.store_sv.chat_current_customer_status = val.presence;
      let temp_sv_name = find(this.$store.state.store_sv.chat_sv_helper_info_list, function (o) {
        return o.questioner_id == val.id;
      });

      if (!temp_sv_name) {
        this.$store.state.store_sv.sv_help_onSupportFlg = false;
      }
      //  let temp_bling = find(this.$store.state.store_sv
      // .sv_help_isBlingFlg_list, function (o) { return o.questioner_id == val.id});

      // if(!temp_bling){
      //   this.$store.state.store_sv.sv_help_isBlingFlg = false;
      // }
      this.$store.state.sysInit.pi_chat_questioner_logo = val.logo_url;
      // 未解決チケット取得する
      let phoneNumber = val.phone_number ? val.phone_number : val.id;
      let currentIssueId = val.issue_id ? val.issue_id : val.issueId
      this.$store.dispatch("sysInit/getUnsolvedIssueListByPhone", { phoneNum: phoneNumber, currentIssueId: currentIssueId });
      // SET THE first unsolved issue
      // this.$store.dispatch("sysInit/getchatbotAllText", { val });
      this.$store.dispatch("sysInit/getAllInfoToManualChatPi", {
        telNum: val.user_id,
        chatStatus: "isclosed",
      });

      this.$store.state.sysInit.piIssuesVisible = true;
    },

    getQuestionerId(row, event, colum) {
      this.clickedRow = row;
      this.$store.state.sysInit.temp_selected_logo_cti = row.logo_url;

      this.resetAllSelected();
      let val = row;
      val.current_waiting = true;
      val.selected = true;
      Vue.set(this.$store.state.sysInit.presenceInfoObj.waiting,0,this.$store.state.sysInit.presenceInfoObj.waiting[0]);

      this.$store.state.sysInit.chat_current_status = "isWaiting";
      this.$store.state.discovery.autoCompleteInputText = "";
      this.$store.state.discovery.editorText = "";
      this.$store.state.sysInit.manualChatModeIssueId = "";
      this.$store.state.sysInit.manualChatShowWaitingListFlg = true;
      this.$store.state.sysInit.piCustomerVisible = true;
      this.$store.state.sysInit.piChatbotVisible = true;
   
      this.$store.state.store_sv.chat_current_customer_status = val.presence;
      this.$store.state.sysInit.searchConditionForm.phone_number = val.id;

      // 未解決チケット取得する
      let phoneNumber = val.phone_number ? val.phone_number : val.id;
      this.$store.dispatch("sysInit/getUnsolvedIssueListByPhone", { phoneNum: phoneNumber });

      this.$store.dispatch("sysInit/searchByCondition", {
        params: this.$store.state.sysInit.searchConditionForm,
      });

      let temp_sv_name = find(this.$store.state.store_sv.chat_sv_helper_info_list, function (o) {
        return o.questioner_id == val.id;
      });

      if (!temp_sv_name) {
        this.$store.state.store_sv.sv_help_onSupportFlg = false;
      }

      // let temp_bling = find(this.$store.state.store_sv
      // .sv_help_isBlingFlg_list, function (o) { return o.questioner_id == val.id});

      // if(!temp_bling){
      //   this.$store.state.store_sv.sv_help_isBlingFlg = false;
      // }

      this.$store.state.sysInit.pi_chat_questioner_logo = val.logo_url;
      console.log(val);
      this.$store.dispatch("sysInit/getAllInfoToManualChatPi", {
        telNum: val.id,
        chatStatus: "",
      });
      this.$store.state.sysInit.piIssuesVisible = true;
      this.$store.state.sysInit.manualChatCreateIssueUserId = val.id;
      // this.$store.state.sysInit.manualChatQuestionerId = val.id;
      // if(this.$store.state.sysInit.manualChatUserList.indexOf(val.id) != -1){
      //   console.log(val.id);
      // this.$store.state.sysInit.manualChatQuestionerId = val.id;
      // }else{
      // this.$store.state.sysInit.manualChatQuestionerId = val.id;
      // }

      //holdon
      this.$store.state.sysInit.showHoldOnButton = true;

      if (val.presence == "waitClose") {
        this.$store.state.sysInit.manualChatSendMessageFlg = false;
      } else {
        this.$store.state.sysInit.manualChatSendMessageFlg = true;
      }

      ////////
      // console.log("this.$store.state.sysInit.manualChatUserCount",this.$store.state.sysInit.manualChatUserCount)
      if (
        this.$store.state.sysInit.manualChatUserCount >= this.$store.state.sysInit.currentUserCount
      ) {
        this.$store.state.sysInit.manualButtonDisabled = true;
        // console.log("到达上限!!!!!");
      } else {
        this.$store.state.sysInit.manualButtonDisabled = false;
      }
      // this.$store.state.sysInit.chatBotUserIdList
      // set the first unsolved issue 
      // this.$store.dispatch("sysInit/getUC1IssueAllText", { val });
      // issue_startTime
      this.$store.state.sysInit.issue_startTime = val.startTime;

      let escalationStart = moment(val.startTime.replace(/T/g, " ").replace(/\.[\d]{3}Z/, "")).valueOf();
      let timeBetween = moment(moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss")).valueOf() - escalationStart;

      // 日
      let days = Math.floor(timeBetween / (24 * 3600 * 1000));
      // 時間
      let hoursRound =  timeBetween % (24 * 3600 * 1000);
      let hours = Math.floor(hoursRound / (3600 * 1000)) + days * 24;
      // 分
      let minutesRound = hoursRound % (3600 * 1000);
      let minutes = Math.floor(minutesRound / (60 * 1000));
      // 秒
      let secondsRound = minutesRound % (60 * 1000);
      let seconds = Math.floor(secondsRound / (1000));
      // マイナスの場合、０としてセット
      let waitedTimeStr = "00:00:00";
      if (hours >= 0 && minutes >= 0 && seconds >= 0){
        waitedTimeStr = [String(hours).padStart(2, '0') , String(minutes).padStart(2, '0'), String(seconds).padStart(2, '0')].join(":");
      }

      this.$store.state.sysInit.issue_waitedTime = waitedTimeStr;
      // let tempTime = moment(val.startTime)
      //   .utcOffset(0)
      //   .format("YYYY-MM-DD HH:mm:ss");

      // let data = {
      //   userId: val.id,
      //   issueId:"",
      //   manualChatStartTime: tempTime,
      // };
      // this.$store.state.sysInit.manualChatStartTimeList.push(data);

      this.$store.state.sysInit.manualChatQuestionerName = VueUtils.computeFullName(val.lastname, val.firstname);

      // button status
      // let button_data={
      //   userId:val.id,
      //   buttonStatus:val.buttonStatus,
      // }
      //  this.$store.state.sysInit.manualChatStartButtonList.push(button_data);
      this.$store.state.sysInit.manualChatButtonStatus = "open";

      // this.$store.state.sysInit.manualButtonDisabled = false;

      // console.log(val.buttonStatus);
    },
    getInfoFromchating(row, event, colum) {
      this.clickedRow = row;
      this.$store.state.sysInit.temp_selected_logo_cti = row.logo_url;

      this.$store.state.sysInit.chat_current_status = "isChating";
      this.$store.state.discovery.autoCompleteInputText = "";
      this.$store.state.discovery.editorText = "";
      this.$store.state.sysInit.manualChatShowWaitingListFlg = false;
      this.$store.state.sysInit.piCustomerVisible = true;
      this.$store.state.sysInit.piChatbotVisible = true;
      let val = row;
      this.resetAllSelected();
      val.userOnChecked = true;
      val.selected = true;
      Vue.set(this.$store.state.sysInit.presenceInfoObj.chating,0,this.$store.state.sysInit.presenceInfoObj.chating[0]);

      this.$store.state.store_sv.chat_current_customer_status = val.presence;
      this.$store.state.sysInit.pi_chat_questioner_logo = val.logo_url;
      console.log(val);
      this.$store.state.sysInit.searchConditionForm.phone_number = val.id;
      // 未解決チケット取得する
      let phoneNumber = val.phone_number ? val.phone_number : val.id;
      let currentIssueId = val.issue_id ? val.issue_id : val.issueId
      this.$store.dispatch("sysInit/getUnsolvedIssueListByPhone", { phoneNum: phoneNumber, currentIssueId: currentIssueId });

      this.$store.dispatch("sysInit/searchByCondition", {
        params: this.$store.state.sysInit.searchConditionForm,
      });
      // this.$store.dispatch("sysInit/getchatbotAllText", { val });

      this.$store.dispatch("sysInit/getAllInfoToManualChatPi", {
        telNum: val.id,
        chatStatus: "",
        excludeIssueId: val.issue_id ? val.issue_id : val.issueId
      });

      this.$store.state.sysInit.piIssuesVisible = true;
      this.$store.state.sysInit.manualButtonDisabled = false;
      this.$store.state.sysInit.manualChatMessageList.sort();


      // this.$store.state.sysInit.presenceInfoObj.chating.sort();
      console.log(this.$store.state.sysInit.presenceInfoObj.chating);
      this.$store.state.sysInit.manualChatModeIssueId = val.issueId;
      // this.$store.state.sysInit.manualButtonDisabled = false;
      this.$store.state.sysInit.manualChatQuestionerId = val.id;

      let temp_sv_name = find(this.$store.state.store_sv.chat_sv_helper_info_list, function (o) {
        return o.questioner_id == val.id;
      });

      if (temp_sv_name) {
        this.$store.state.store_sv.sv_help_onSupportFlg = true;
        this.$store.state.store_sv.sv_help_isBlingFlg = false;
        this.$store.state.store_sv.chat_sv_name = temp_sv_name.svName;
        // this.$store.state.store_sv.chat_sv_svExtension = temp_sv_name.svExtension;
      } else {
        this.$store.state.store_sv.sv_help_onSupportFlg = false;
        let temp_bling = find(this.$store.state.store_sv.sv_help_isBlingFlg_list, function (o) {
          return o.questioner_id == val.id;
        });

        if (!temp_bling) {
          this.$store.state.store_sv.sv_help_isBlingFlg = false;
        } else {
          this.$store.state.store_sv.sv_help_isBlingFlg = true;
        }
      }

      if (val.presence == "waitClose") {
        // this.userChecked = "success"
        this.$store.state.sysInit.manualChatButtonStatus = "close";
        // sysInit.piMessageFlag = false;
        // sysInit.chatPiMessageWs.close();

        this.$store.state.redmine.issue_id = val.issueId;
        // this.$store.state.sysInit.manualChatModeIssueId = val.issueId;
        // this.$store.state.sysInit.manualButtonDisabled = false;
        // this.$store.state.sysInit.manualChatQuestionerId = val.id;

        if (this.$store.state.sysInit.holdOnUserList.length > 0) {
          if (this.$store.state.sysInit.holdOnUserList.indexOf(val.issueId) != -1) {
            this.$store.state.sysInit.showHoldOnButton = false;
          } else {
            this.$store.state.sysInit.showHoldOnButton = true;
          }
        } else {
          this.$store.state.sysInit.showHoldOnButton = true;
        }

        this.$store.state.sysInit.manualChatSendMessageFlg = false;
        // this.$store.state.sysInit.chatPiDiaLogVisible = false;
      } else {
        // this.userChecked = "success"
        this.$store.state.sysInit.manualChatButtonStatus = "close";
        // sysInit.piMessageFlag = false;
        // sysInit.chatPiMessageWs.close();

        this.$store.state.redmine.issue_id = val.issueId;
        // this.$store.state.sysInit.manualChatModeIssueId = val.issueId;
        // this.$store.state.sysInit.manualButtonDisabled = false;
        // this.$store.state.sysInit.manualChatQuestionerId = val.id;
        //holdon
        if (this.$store.state.sysInit.holdOnUserList.length > 0) {
          if (this.$store.state.sysInit.holdOnUserList.indexOf(val.issueId) != -1) {
            this.$store.state.sysInit.showHoldOnButton = false;
          } else {
            this.$store.state.sysInit.showHoldOnButton = true;
          }
        } else {
          this.$store.state.sysInit.showHoldOnButton = true;
        }

        // sysInit.piMessageFlag = true;
        this.$store.dispatch("sysInit/connectChatPiMessageSocket", {
          userId: val.id,
        });

        // if(val.presence =="waitClose"){
        //   this.$store.state.sysInit.manualChatSendMessageFlg = false;
        // }else{
        this.$store.state.sysInit.manualChatSendMessageFlg = true;
        // }
        // sysInit.piMessageFlag = true;
        // sysInit.chatPiMessageWs.reconnect();

        // sysInit.chatPiMessageWsUrl =
        //   chatPiMessageWsUrl = state.nexmo_websocket_uri + "chat/message?userId=" + state.manualChatQuestionerId + "&operatorId=" + state.user_id + "&type=UC2" + "&issueId=" + state.manualChatModeIssueId;
        // this.$store.dispatch("sysInit/connectChatPiMessageSocket");
        if (val.presence == "notRead") {
          if (val.notReadList.length > 0) {
            for (let i = 0; i < val.notReadList.length; i++) {
              let data = {
                id: this.$store.state.sysInit.messageId++,
                flag: "right",
                userId: val.id,
                text: val.notReadList[i].message,
                checked: false,
                user: this.$store.state.sysInit.html_const.cons_217_questioner,
                messageTime: moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm:ss"),
                issueId: val.issueId,
                isChatbot: false,
                status: false,
                username: VueUtils.computeFullName(val.lastname, val.firstname),
                logo_url: val.logo_url,
                // chatbotIssueId:this.$store.state.sysInit.manualChatbotIssueId
              };
              this.$store.state.sysInit.manualChatMessageList.push(data);

              this.$store.dispatch("redmine/manualChatMessageRecord", {}, { root: true });

              let item = {
                flag: data.flag,
                text: data.text,
                mode: this.$store.state.sysInit.ws_mode,
              };

              this.$store.dispatch("stt/fetchKeywordByDialogRight", {
                ...item,
                request_id: this.$store.state.redmine.issue_id,
                keywordRate: this.$store.state.sysInit.keywordRate,
              });
            }
          }
        }
        // this.$store.dispatch("sysInit/getAllInfoToManualChatPi", {
        //   telNum: val.id,
        // });

        let statusList = ["notSend", "isWriting", "sendEnd", "waitClose"];
        if (statusList.indexOf(val.presence)) {
          this.$store.state.sysInit.manualButtonStatus = "manualEnd";
        }
        // console.log(
        //   "this.$store.state.sysInit.manualChatQuestionerId",
        //   this.$store.state.sysInit.manualChatQuestionerId
        // );
        // console.log(
        //   " this.$store.state.sysInit.manualChatModeIssueId",
        //   this.$store.state.sysInit.manualChatModeIssueId
        // );

        let status = val.presence;
        let sendStatus = "";
        // let statusList = ["notSend", "isWriting", "sendEnd", "waitClose"];
        // sendStatus = "changeUser";
        // if (this.$store.state.sysInit.manualChatQuestionerId) {
        //   this.$store.state.sysInit.manualMessageStatus = sendStatus;
        //   this.$store.dispatch("sysInit/changeManualChatMessageStatus");
        //   this.$store.state.sysInit.manualButtonStatus = "manualEnd";
        // }
        // if (status == "answered") {
        //   sendStatus = "notSend";
        //   if (this.$store.state.sysInit.manualChatQuestionerId) {
        //     this.$store.state.sysInit.manualMessageStatus = sendStatus;
        //     this.$store.dispatch("sysInit/changeManualChatMessageStatus");
        //     this.$store.state.sysInit.manualButtonStatus = "manualEnd";
        //   }
        // }
        if (status == "notRead") {
          sendStatus = "notSend";
          if (this.$store.state.sysInit.manualChatQuestionerId) {
            this.$store.state.sysInit.manualMessageStatus = sendStatus;
            this.$store.dispatch("sysInit/changeManualChatMessageStatusWhenNotRead");
            this.$store.state.sysInit.manualButtonStatus = "manualEnd";
          }
        } else {
          sendStatus = "changeUser";
          if (this.$store.state.sysInit.manualChatQuestionerId) {
            this.$store.state.sysInit.manualMessageStatus = sendStatus;
            this.$store.dispatch("sysInit/changeManualChatMessageStatus");
            this.$store.state.sysInit.manualButtonStatus = "manualEnd";
          }
        }

        // this.$store.state.sysInit.chatPiDiaLogVisible = false;
      }

      // this.$store.state.sysInit.manualButtonDisabled = false;
    },

    changeMessageStatus(val) {},

    showCategoryById(row, event, colum) {
      console.log("row", typeof row.category_tag, row);
      let temp_categoryList = row.category_tag.split(/\s+/g);
      console.log("temp_categoryList", temp_categoryList);
      let temp_categoryList2 = [];
      for (let i of temp_categoryList) {
        if (i) {
          temp_categoryList2.push(i);
        }
      }
      this.categoryList = temp_categoryList2;
      console.log("categoryList", this.categoryList);
    },

    cellStyle({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (columnIndex === 0) {
        //指定坐标rowIndex ：行，columnIndex ：列
        return "background:#4DB1EC ; color:#FFFFFF;padding-left:5px";
      } else if (columnIndex === 1) {
        if (rowIndex % 2 == 1) {
          return "height:25px;background:#E6E6E6;font-weight:normal;padding-left:5px ";
        } else {
          return "height:25px;background:#F2F2F2;font-weight:normal;padding-left:5px ";
        }
      }
      // else {
      //   return "height:20px;background:#E6E6E6";
      // }
    },
    cellStyle_1({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (columnIndex === 0) {
        //指定坐标rowIndex ：行，columnIndex ：列
        return "color:#FFFFFF;background:#4DB1EC;";
      } else if (columnIndex === 2) {
        return "color:#FFFFFF;height:30px;background:#4DB1EC;padding-left:10px";
      } else if (columnIndex === 1) {
        if (rowIndex % 2 == 1) {
          return "height:20px;background:#E6E6E6;font-weight:normal;padding-left:5px ";
        } else {
          return "height:20px;background:#F2F2F2;font-weight:normal;padding-left:5px ";
        }
        // return "height:30px;background:#E6E6E6";
      } else {
        if (rowIndex % 2 == 1) {
          return "height:20px;background:#E6E6E6;font-weight:normal;padding-left:5px ";
        } else {
          return "height:20px;background:#F2F2F2;font-weight:normal;padding-left:5px ";
        }
      }
    },
    cellStyle2({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (rowIndex === 0) {
        //指定坐标rowIndex ：行，columnIndex ：列

        if (this.$store.state.sysInit.piIssueStatusFlg) {
          return "background:#F2F2F2;color:#0000FF";
        } else {
          return "background:#F2F2F2";
        }
      } else if (rowIndex % 2 == 1) {
        return "background:#E6E6E6";
      } else {
        return "background:#F2F2F2";
      }
    },
    cellStyle3({ row, column, rowIndex, columnIndex }) {
      // console.log("columnIndex", columnIndex);
      if (rowIndex % 2 == 1) {
        //指定坐标rowIndex ：行，columnIndex ：列
        return "background:#E6E6E6";
      } else {
        return "background:#F2F2F2";
      }
    },

    cellStyle_search_consequence({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background:#F2F2F2;color:#0000FF";
      }
    },

    ChatingSortByTime() {
      if (this.$store.state.sysInit.chat_ChatingSortByTimeFlg) {
        this.$store.state.sysInit.presenceInfoObj.chating = _.sortBy(
          this.$store.state.sysInit.presenceInfoObj.chating,
          function (o) {
            return o.startTime;
          }
        ).reverse();
      } else {
        this.$store.state.sysInit.presenceInfoObj.chating = _.orderBy(
          this.$store.state.sysInit.presenceInfoObj.chating,
          ["similarity"],
          ["desc"]
        );
      }
    },
    waitingSortByTime() {
      if (this.$store.state.sysInit.chat_WaitingSortByTimeFlg) {
        // this.$store.state.sysInit.presenceInfoObj.waiting =   _.orderBy(this.$store.state.sysInit.presenceInfoObj.waiting,['startTime'],['desc']);
        // sortBy(this.$store.state.sysInit.piRecordInfoObj.piRecordInfo, function(o) { return o.call_end_time; }).reverse();
        this.$store.state.sysInit.presenceInfoObj.waiting = _.sortBy(
          this.$store.state.sysInit.presenceInfoObj.waiting,
          function (o) {
            return o.startTime;
          }
        ).reverse();
      } else {
        this.$store.state.sysInit.presenceInfoObj.waiting = _.orderBy(
          this.$store.state.sysInit.presenceInfoObj.waiting,
          ["similarity"],
          ["desc"]
        );
      }
    },
    endingSortByTime() {
      if (this.$store.state.sysInit.chat_EndingSortByTimeFlg) {
        this.$store.state.sysInit.presenceInfoObj.ending = _.orderBy(
          this.$store.state.sysInit.presenceInfoObj.ending,
          ["chat_end_time"],
          ["desc"]
        );
      } else {
        this.$store.state.sysInit.presenceInfoObj.ending = _.orderBy(
          this.$store.state.sysInit.presenceInfoObj.ending,
          ["similarity"],
          ["desc"]
        );
      }
    },

    dropdownSort(command) {
      // console.log(command)
      if (command == "sortByTime") {
        // this.$store.state.sysInit.chat_ChatingSortByTimeFlg = true;
        this.$store.state.sysInit.chat_WaitingSortByTimeFlg = true;
        // this.$store.state.sysInit.chat_EndingSortByTimeFlg = true;
        this.$store.state.sysInit.dropdownSortTitle = "先着順";
      } else {
        // this.$store.state.sysInit.chat_ChatingSortByTimeFlg = false;
        this.$store.state.sysInit.chat_WaitingSortByTimeFlg = false;
        // this.$store.state.sysInit.chat_EndingSortByTimeFlg = false;
        this.$store.state.sysInit.dropdownSortTitle = "相性順";
      }
    },

    changeHighlight(row, column, event) {
      // console.log(row)
      // searchConsequenceTable
      if (row) {
        this.$refs.searchConsequenceTable.setCurrentRow(row, true);
      } else {
        this.$refs.searchConsequenceTable.setCurrentRow(-1);
      }
    },
    changeHighlight2(row, column, cell, event) {
      console.log(row);
      console.log(column);
      console.log(cell);
      console.log(event);
      // this.$refs.searchConsequenceTable.setCurrentRow(-1)
      //          if(row){
      // console.log(row)
      //          }else{
      // this.$refs.searchConsequenceTable.setCurrentRow(-1)
      //          }
    },
    changeHighlight3() {
      this.$refs.searchConsequenceTable.setCurrentRow(-1);
    },

    changeShowSearchCondition() {
      this.$store.state.sysInit.isShowSearchCondition =
        !this.$store.state.sysInit.isShowSearchCondition;
    },
    changeShowSearchConsequence() {
      this.$store.state.sysInit.isShowSearchConsequence =
        !this.$store.state.sysInit.isShowSearchConsequence;
    },

    submitSearchConditionForm() {
      this.$store.state.sysInit.isSearchLoading = true;

      console.log(this.$store.state.sysInit.searchConditionForm);
      this.$store.dispatch("sysInit/searchByCondition", {
        params: this.$store.state.sysInit.searchConditionForm,
      });

      // searchByCondition
    },
    resetSearchConditionForm() {
      this.$store.state.sysInit.searchConditionForm.id = "";
      this.$store.state.sysInit.searchConditionForm.name = "";
      this.$store.state.sysInit.searchConditionForm.phone_number = "";
      this.$store.state.sysInit.searchConditionForm.email = "";
      this.$store.state.sysInit.searchConditionForm.birthday = "";
      this.$store.state.sysInit.searchConditionForm.address = "";
    },
    chat_searchDetailed(row) {
      this.$store.state.sysInit.searchDetail_pi_loading = true;
      this.$store.state.sysInit.searchDetail_piIssuesVisible = true;
      this.$store.state.sysInit.searchDetail_piCustomerVisible = true;

      if (row.logo_url) {
        this.$store.state.sysInit.searchDetailUserLogo = row.logo_url;
      } else {
        this.$store.state.sysInit.searchDetailUserLogo = this.$store.state.sysInit.questioner_logo;
      }

      this.$store.state.sysInit.searchDetailTitle.name = row.customer_name;
      this.$store.state.sysInit.searchDetailTitle.id = row.id;
      this.$store.state.sysInit.searchDetailDialogVisible = true;
      let val = row.phone_number;
      this.$store.dispatch("sysInit/searchDetail_getAllInfoToPi", {
        telNum: val,
      });
      console.log(row);
    },
    searchDetailDialogClose() {
      this.$store.state.sysInit.searchDetailDialogVisible = false;
    },

    addNewUserDialogOpen() {
      this.$store.state.sysInit.addNewUserDialogVisible = true;
    },
    addNewUserDialogClose() {
      this.$store.state.sysInit.newUserInfoForm.phone_number = "";
      this.$store.state.sysInit.newUserInfoForm.firstname = "";
      this.$store.state.sysInit.newUserInfoForm.lastname = "";
      this.$store.state.sysInit.newUserInfoForm.mail = "";
      this.$store.state.sysInit.newUserInfoForm.sex = "";
      this.$store.state.sysInit.newUserInfoForm.birthday = "";
      this.$store.state.sysInit.newUserInfoForm.former_address = "";
      this.$store.state.sysInit.newUserInfoForm.current_address = "";
      this.$store.state.sysInit.newUserInfoForm.customer_name_yomi = "";
      this.$store.state.sysInit.addNewUserDialogVisible = false;
    },
    resetNewUserForm() {
      this.$store.state.sysInit.newUserInfoForm.phone_number = "";
      this.$store.state.sysInit.newUserInfoForm.firstname = "";
      this.$store.state.sysInit.newUserInfoForm.lastname = "";
      this.$store.state.sysInit.newUserInfoForm.mail = "";
      this.$store.state.sysInit.newUserInfoForm.sex = "";
      this.$store.state.sysInit.newUserInfoForm.birthday = "";
      this.$store.state.sysInit.newUserInfoForm.former_address = "";
      this.$store.state.sysInit.newUserInfoForm.current_address = "";
      this.$store.state.sysInit.newUserInfoForm.customer_name_yomi = "";
      this.$store.state.sysInit.addNewUserDialogVisible = false;
    },
    submitNewUserForm() {
      console.log(this.$store.state.sysInit.newUserInfoForm);

      if (
        this.$store.state.sysInit.newUserInfoForm.phone_number &&
        this.$store.state.sysInit.newUserInfoForm.firstname &&
        this.$store.state.sysInit.newUserInfoForm.lastname &&
        this.$store.state.sysInit.newUserInfoForm.customer_name_yomi &&
        this.$store.state.sysInit.newUserInfoForm.mail &&
        this.$store.state.sysInit.newUserInfoForm.birthday &&
        this.$store.state.sysInit.newUserInfoForm.current_address
      ) {
        this.$store.dispatch("sysInit/addNewUser", {
          params: this.$store.state.sysInit.newUserInfoForm,
        });
      } else {
        Message.warning({
          message: this.$store.state.sysInit.html_const.cons_270_add_new_customer_warning_message,
        });
      }
    },

    chatConfirmed(userInfo) {
      this.$store.dispatch("sysInit/changeCustomerInfoConfirm", {
        params: userInfo.phone_number,
      });
      userInfo.is_confirmed = 1;
    },

    tablerowclassname({row, rowindex}) {
      if (this.clickedRow) {
        if(row.selected || (row.hasOwnProperty('issueId') && row['issueId'] == this.clickedRow['issueId']) || 
        (row.hasOwnProperty('issue_id') && row['issue_id'] == this.clickedRow['issue_id']) || 
        (row.hasOwnProperty('id') && row['id'] == this.clickedRow['id'])){
          return 'selected-row';
        }else{
          return 'non-selected-row';
        }
      } else {
        return 'non-selected-row';
      }
    }
  },
};
</script>
<style lang="scss">
.selected-row,.selected-row td{
  background: #ffeaea !important;
}
.non-selected-row,.non-selected-row td{
  background: white !important;
}
.wrapper {
  width: 40vw;
}
.wrapper_border {
  // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: solid;
  border-color: #cccccc;
}
.intrinsic-aspect-ratio-container {
  width: 48%;
  height: 195px;
  padding: 5px;
  // padding-bottom: 10%;
  margin-top: 5px;
  // margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 0px;
  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_summary_1 {
  width: 48%;
  height: 165px;
  // padding: 5px;
  // padding-bottom: 10%;
  margin-top: 5px;
  margin-right: 10px;
  margin-left: 10px;
  // margin-bottom: 0px;
  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_chatbot {
  width: 95%;
  height: 350px;
  // padding: 5px;
  // padding-bottom: 10%;
  margin-top: 5px;
  // margin-right: 10px;
  margin-left: 20px;
  padding-left: 100px;
  padding-right: 100px;
}

.intrinsic-aspect-ratio-container1 {
  width: 48%;
  height: 195px;
  padding: 5px;
  // padding-bottom: 10%;
  margin-top: 5px;
  // margin-right: 10px;
  margin-bottom: 0px;
  margin-left: 10px;
  // background-color: lightsalmon;
}

.intrinsic-aspect-ratio-container_summary_2 {
  width: 48%;
  height: 165px;
  padding: 5px;
  // padding-bottom: 10%;
  margin-top: 5px;
  margin-right: 10px;
  margin-bottom: 0px;
  margin-left: 3px;
  // background-color: lightsalmon;
}

.intrinsic-aspect-ratio-container2 {
  width: 48%;
  height: 195px;
  padding: 5px;
  // padding-bottom: 15%;
  margin-top: 5px;
  // margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 0px;
  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container2_Summary {
  width: 97.5%;
  height: 260px;
  padding: 5px;
  // padding-bottom: 15%;
  margin-top: 5px;
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 0px;
  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container4 {
  width: 48%;
  height: 195px;
  padding: 5px;
  // padding-bottom: 15%;
  margin-top: 5px;
  // margin-right: 10px;
  // margin-left: 10px;
  margin-bottom: 0px;
  // background-color: lightsalmon;
}

.intrinsic-aspect-ratio-container3 {
  width: 150%;
  padding: 10px;
  padding-bottom: 0%;
  margin: 0px;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button {
  width: 98%;
  // padding: 10px;
  padding-bottom: 7.3%;
  // margin-top: 40px;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button1 {
  width: 98%;
  padding: 14px;
  padding-bottom: 0%;
  // margin-top: 15px;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button3 {
  width: 98%;
  // padding: 30px;
  padding-bottom: 2.85%;
  // margin-top: 11px;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button4 {
  width: 98%;
  // padding: 10px;
  padding-bottom: 3.4%;
  // margin-top: 29px;

  // background-color: lightsalmon;
}
.intrinsic-aspect-ratio-container_button_div {
  margin-top: 10px;
  text-align: center;
}
.pi_title_color {
  color: #808080;
  font-size: 15px;
  font-weight: 800;
  // margin: 12px;
}
.pi_text_color {
  color: #808080;
  font-size: 16px;
  font-weight: 400;
  // margin: 12px;
  line-height: 20px;
  padding-left: 12px;
}
[v-cloak] {
  display: none;
}

.pi_progress {
  width: 50%;
  // display: inline-block;
  text-align: right;
  float: right;
}
.pi_text_color_progress {
  min-width: 50px;
  color: #808080;
  font-size: 16px;
  font-weight: 400;
  padding-left: 40px;
  // padding-right: 30px;
  line-height: 48px;
  flex: auto;
}
.el-progress {
  width: 80%;
}
.pi_collapse {
  display: inline-block;
  height: 500px;
  overflow: auto;
}
.el-collapse {
  height: 90%;
}

.ticket_collapse {
  .el-collapse-item {
    margin-bottom: 0px;
  }

  .el-collapse-item__header {
    // display: -webkit-box;
    // display: -ms-flexbox;
    // display: flex;
    // -webkit-box-align: center;
    // -ms-flex-align: center;
    // align-items: center;
    // color: #303133;
    // cursor: pointer;
    // border-bottom: 0px solid #ebeef5;
    // font-size: 13px;
    // font-weight: 500;
    // -webkit-transition: border-bottom-color 0.3s;
    // transition: border-bottom-color 0.3s;
    // outline: 0;
    background-color: #fff !important;
    height: 60px !important;
    line-height: 15px;
  }
}
.el-collapse-item__header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  color: #303133;
  cursor: pointer;
  border-bottom: 0px solid #ebeef5;
  font-size: 13px;
  font-weight: 500;
  // -webkit-transition: border-bottom-color 0.3s;
  // transition: border-bottom-color 0.3s;
  outline: 0;
  background-color: #d9d9d9;
}
.dialog-data .el-dialog__body {
  padding: 0px;
  .el-table .el-table__cell {
    padding: 0px;
  }
}
.el-tabs .el-tab-pane {
  height: 590px;
}

// .img_questioner {
//   // padding: 5px;
//   margin-left: 25px;
//   width: 45px;
//   height: 45px;
// }
// .img_questioner1{
//   // padding: 5px;
//   margin-left: 15px;
//   margin-right: 10px;
//   width: 45px;
//   height: 45px;
// }
.img_operatorPi {
  // padding: 5px;
  border-radius: 50%;
  margin-left: 11px;
  width: 45px;
  height: 45px;
}
// .img_splitLine {
//   width: 70px;
//   height: 2px;
// }

.message_presence {
  font-size: 10px;
}
.message_op_name {
  margin-left: 10px;
  font-size: 10px;
}
.message_qu_name {
  margin-left: 24px;
  font-size: 10px;
}
.message_time {
  // margin-left: 15px;
  font-size: 10px;
}
.message_time1 {
  // margin-left: 15px;
  font-size: 10px;
}
.cti_collapse .el-collapse-item__wrap {
  //height: calc(100% - 48px) !important;
  
  border-bottom: 0px solid #ebeef5 !important;
  box-sizing: 0;
  overflow: hidden !important;
}

.cti_collapse .el-collapse-item__content {
  padding-bottom: 0px !important;
  font-size: 10px !important;
  color: #303133 !important;
}
.el-dialog__wrapper2 {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: visible;
  margin: 0;
}
.el-tag1 {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  height: 17px;
  padding: 0 10px;
  line-height: 15px;
  font-size: 10px;
  color: #409eff;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
}
.el-tag2 {
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  height: 20px;
  padding: 0 10px;
  line-height: 18px;
  font-size: 12px;
  color: #409eff;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  margin-bottom: 2px;
}
.currentUser {
  background-color: #ecf5ff;
}

.el-table .cell {
  padding-left: 0px;
}
// .el-table--border {
//     border-right: none !important;
//     border-bottom: none !important;
// }
.el-table .success-row {
  background: #ffeaea;
  // border:5px solid red;
}
.el-main_chat {
  height: 100%;
  padding: 0px;
}
.customer-table {
  height: 190px;
  overflow: auto;
}

::-webkit-scrollbar {
  width: 6px;
  height: 8px;
  background-color: #ebeef5;
}
::-webkit-scrollbar-thumb {
  // border-radius:2px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #ccc;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background: rgba(255, 255, 255, 1);
}

aside .el-table {
  border-top: 0px solid #ebeef5 !important;
  border-bottom: 0px solid #ebeef5 !important;
  margin-top: 10px;
}

.el-dropdown-link-chat {
  cursor: pointer;
  color: #9F014E;
  background-color: #FAD0E4;
  border: 1px solid #FF9BCC;
  padding: 2px 3px;
  border-radius: 5px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
// .el-dropdown-menu__item:not(.is-disabled):hover{
//     background-color: #FD6622 !important;
//     color: #333333 !important;
//  }

.search-condition-not-expanded {
  font-size: 12px;
}
.search-condition-expanded {
  font-size: 12px;
}

.search-consequence-not-expanded {
  padding-top: 10px;
  font-size: 12px;
}
.search-consequence-expanded {
  padding-top: 10px;
  font-size: 12px;
}
.el-form-item--mini .el-form-item__label {
  line-height: 12px;
  font-size: 12px;
  font-weight: bolder;
  text-align: left;
}
.el-badge__content {
  background-color: #f56c6c;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: 12px;
  height: 16px;
  line-height: 16px;
  padding: 0 3px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
}

.el-badge__content.is-fixed {
  position: absolute;
  top: 0;
  right: 12px;
  -webkit-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(100%);
}
.el-table tr td.td-is-left {
  text-align: left;
}
</style>
<style lang="scss" scoped>
.content-img-width ::v-deep(img) {
  width: 100%;
}

#img_head_back_left_bottom {
  background-color: #ff56a7;
  position: absolute;
  width: 50px;
  left: 169px;
  z-index: 10;
}

.img_heart_left_bottom {
  height: 50px;
  width: 50px;
  position: absolute;
  top: 60px;
  left: 169px;
  z-index: 20;
}
.el-dropdown-menu__item:hover {
  background-color: #FAD0E4;
  color: #9F014E;
}
.veryHighPi{
  color: #039987;
}
.highPi{
  color: #1AA628;
}
.decentPi{
  color: #85980E;
}
.lowPi{
  color: #F14545;
}
.heartHover{
  object-fit: none;

}
</style>
